var PRIMEControllersT2D = angular.module('PRIMEControllersT2D', []).run(function($rootScope) {
	  
})

PRIMEControllersT2D.constant('FeatureFlags', window.APP_FLAGS || {
	obesityMode: false,
	vertexMode: false
});

PRIMEControllersT2D.controller("HomeT2D", function ($scope) {
	$scope.strings = {
		"title":"Home",
		"welcome":"Welcome to the PRIME Diabetes Model for Type 2 Diabetes Mellitus in Adults"
	}
});

// ===============================================
// Cohorts T2D
// ===============================================
PRIMEControllersT2D.controller("CohortsT2D", ["$scope", "$routeParams", "$location", "$modal", "$controller", "CohortT2D", function ($scope, $routeParams, $location, $modal, $controller, CohortT2D, NewCohortT2D, EditCohortT2D) {

	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCohort = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/cohort-new.html?v=1.5.5",
			controller: "NewCohortT2D",
			size: size,
			resolve: {
				cohorts: function () {
					return $scope.cohorts;
				}
			},
		});

		modalInstance.result.then(function (newCohort) {
			newCohort.$save({}, function(data) {
				$scope.cohorts.push(newCohort);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create T2D cohort modal dismissed at: " + new Date());
		});
	}

	$scope.editCohortModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/cohort-new.html?v=1.5.5",
			controller: "EditCohortModalT2D",
			size: size,
			resolve: {
				cohorts: function () { return $scope.cohorts; },
				cohortId: function() { return id; },
        viewOnly: function () { return false;}
			}
		});

		modalInstance.result.then(function (editedCohort) {
			editedCohort.$update({}, function(data) {
				$scope.cohorts.filter(function(cohort, index, cohorts) {
					if (cohort._id === data._id) {
						cohorts[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
		});
		
	}
	
	
	
	$scope.strings = {
		"title":"Type 2 Cohorts",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
    "share":"Share",
		"baselineCharacteristics":"Baseline characteristics",
		"search":"Search cohorts"
	}
	
	$scope.cohorts = CohortT2D.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.cohorts, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.cohorts, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.cohorts.forEach(function(cohort, idx) {
			if (cohort.selected) {
				var duplicateCohort = angular.copy(cohort);
				delete cohort.selected;

				delete duplicateCohort._id;
				delete duplicateCohort.selected;
				duplicateCohort.sharedWith = [];
				duplicateCohort.creationDate = new Date().getTime();
				duplicateCohort.name = duplicateCohort.name + " copy";
				duplicateCohort.clonedFrom = cohort._id;
				
				duplicateCohort.$save({}, function(data) {
					$scope.cohorts.push(duplicateCohort);
					if (options.modal) {
						$scope.editCohortModal('lg', duplicateCohort._id);
					} else {
						$location.path('/t2d/cohort/' + duplicateCohort._id);
					}
				})
			}
		})
	};

  $scope.shareSelected = function() {
    $scope.cohorts.forEach(function(cohort) {
      if (cohort.selected) {
        const id = cohort._id;

        $modal.open({
          templateUrl: "partials/t2d/share-documents.html",
          controller: "ShareDocumentT2D",
          size: 'lg',
          resolve: {
            documentId: function () {
              return id;
            },
            collection: function () {
              return 'cohorts';
            }
          }
        });
      }});
  };
	
	$scope.deleteSelected = function() {
		$scope.cohorts.forEach(function(cohort, idx) {
			if (cohort.selected) {
				cohort.$delete({}, function(data) {
					$scope.cohorts = $scope.cohorts.filter(function(cohort) {
						return cohort._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllersT2D.controller("EditCohortT2D", ["$scope", "$routeParams", "$location", "CohortT2D", "FeatureFlags", function($scope, $routeParams, $location, CohortT2D, FeatureFlags) {
	$scope.strings = {
		"title":"Cohort",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.obesityMode = FeatureFlags.obesityMode;
	$scope.cohort = CohortT2D.get({cohortId:$routeParams.id});
	$scope.backVisible = true;
  $scope.cohort.$promise.then(function(cohort) {
    $scope.readOnly = !cohort.owner;
  });

  $scope.recalcRaceTotals = function() { return recalcRaceTotals($scope) };

  $scope.recalcRaceTotals();

  $scope.$watchGroup([
    'cohort.white.proportion',
    'cohort.black.proportion',
    'cohort.hispanic.proportion',
    'cohort.southEastAsian.proportion',
    'cohort.indian.proportion',
    'cohort.otherrace.proportion'
  ], function() {
    $scope.recalcRaceTotals();
  });
	
	$scope.ok = function () {
		$scope.cohort.$update({}, function(data) {
			$location.path('/t2d/cohorts');
		})
	};

	$scope.cancel = function () {
		$location.path('/t2d/cohorts');
	};
}]);

PRIMEControllersT2D.controller("EditCohortModalT2D", ["$scope", "$modalInstance", "$routeParams", "$location", "CohortT2D", "cohortId", "cohorts", "viewOnly", "FeatureFlags", function($scope, $modalInstance, $routeParams, $location, CohortT2D, cohortId, cohorts, viewOnly, FeatureFlags) {
	$scope.strings = {
		"title":"Cohort",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}

	$scope.obesityMode = FeatureFlags.obesityMode;

	if (cohorts !== null) {
		$scope.cohort = angular.copy(cohorts.filter(function(cohort){
			return cohort._id === cohortId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.cohort.owner;
  } else {
		$scope.cohort = CohortT2D.get({cohortId:cohortId});
    $scope.cohort.$promise.then(function(cohort) {
      $scope.readOnly = viewOnly || !cohort.owner;
      $scope.cohort = cohort;
    });
	}

  $scope.recalcRaceTotals = function() { return recalcRaceTotals($scope) };

  $scope.recalcRaceTotals();

  $scope.$watchGroup([
    'cohort.white.proportion',
    'cohort.black.proportion',
    'cohort.hispanic.proportion',
    'cohort.southEastAsian.proportion',
    'cohort.indian.proportion',
    'cohort.otherrace.proportion'
  ], function() {
    $scope.recalcRaceTotals();
  });

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cohort); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };

}]);

PRIMEControllersT2D.controller("NewCohortT2D", ["$scope", "$modalInstance", "CohortT2D", "DefaultCohortT2D", "DefaultCohorts", "FeatureFlags", function ($scope, $modalInstance, CohortT2D, DefaultCohortT2D, DefaultCohorts, FeatureFlags) {
	$scope.strings = {
		"title":"New T2D cohort",
		"createButton":"Create new T2D cohort",
		"cancelButton":"Cancel"
	}
	$scope.obesityMode = FeatureFlags.obesityMode;

	$scope.create = true;
	$scope.cohort = new CohortT2D(DefaultCohortT2D);
	$scope.cohort.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.changeDefault = function() {
		DefaultCohorts.get({cohortId:$scope.defaultCohort}).$promise.then(function(data) {
			$scope.cohort = new CohortT2D(data);
			$scope.cohort.creationDate = new Date().getTime();
		});
	}

  $scope.recalcRaceTotals = function() { return recalcRaceTotals($scope) };

  $scope.recalcRaceTotals();

  $scope.$watchGroup([
    'cohort.white.proportion',
    'cohort.black.proportion',
    'cohort.hispanic.proportion',
    'cohort.southEastAsian.proportion',
    'cohort.indian.proportion',
    'cohort.otherrace.proportion'
  ], function() {
    $scope.recalcRaceTotals();
  });
	
	$scope.ok = function () { delete $scope.cohort._id; $modalInstance.close($scope.cohort); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);

function recalcRaceTotals(scope) {
  let c = scope.cohort || {};
  scope.raceTotal = (c.white && c.white.proportion || 0) +
    (c.black && c.black.proportion || 0) +
    (c.hispanic && c.hispanic.proportion || 0) +
    (c.southEastAsian && c.southEastAsian.proportion || 0) +
    (c.indian && c.indian.proportion || 0) +
    (c.otherrace && c.otherrace.proportion || 0);
  scope.raceTotal100 = scope.raceTotal > 99.999 && scope.raceTotal < 100.001;
}







// ===============================================
// Treatments T2D
// ===============================================
PRIMEControllersT2D.controller("TreatmentsT2D", ["$scope", "$location", "$modal", "$controller", "TreatmentT2D", function ($scope, $location, $modal, $controller, TreatmentT2D) {

	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newTreatment = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/treatment-new.html?v=1.3.7",
			controller: "NewTreatmentT2D",
			size: size,
			resolve: {
				treatments: function () {
					return $scope.treatments;
				}
			}
		});

		modalInstance.result.then(function (newTreatment) {
			newTreatment.$save({}, function(data) {
				$scope.treatments.push(newTreatment);
				console.log("New treatment created: ", newTreatment);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create treatment modal dismissed at: " + new Date());
		});
	}
	
	$scope.editTreatmentModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/treatment-new.html?v=1.3.7",
			controller: "EditTreatmentModalT2D",
			size: size,
			resolve: {
				treatments: function () { return $scope.treatments; },
				treatmentId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedTreatment) {
			editedTreatment.$update({}, function(data) {
				$scope.treatments.filter(function(treatment, index, treatments) {
					if (treatment._id === data._id) {
						treatments[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit treatment modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"Type 2 Treatments",
		"search":"Search treatments",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
    "share":"Share"
	}

	$scope.treatments = TreatmentT2D.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.treatments, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.treatments, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.treatments.forEach(function(treatment, idx) {
			if (treatment.selected) {
				var duplicateTreatment = angular.copy(treatment);
				delete treatment.selected;

				delete duplicateTreatment._id;
				delete duplicateTreatment.selected;
				duplicateTreatment.sharedWith = [];
				duplicateTreatment.creationDate = new Date().getTime();
				duplicateTreatment.name = duplicateTreatment.name + " copy";
				duplicateTreatment.clonedFrom = treatment._id;
				
				duplicateTreatment.$save({}, function(data) {
					$scope.treatments.push(duplicateTreatment);
					if (options.modal) {
						$scope.editTreatmentModal('lg', duplicateTreatment._id);
					} else {
						$location.path('/t2d/treatment/' + duplicateTreatment._id);
					}
				})
			}
		})
	}

  $scope.shareSelected = function() {
    $scope.treatments.forEach(function(treatment) {
      if (treatment.selected) {
        const id = treatment._id;

        $modal.open({
          templateUrl: "partials/t2d/share-documents.html",
          controller: "ShareDocumentT2D",
          size: 'lg',
          resolve: {
            documentId: function () {
              return id;
            },
            collection: function () {
              return 'treatments';
            }
          }
        });
      }});
  };
	
	$scope.deleteSelected = function() {
		$scope.treatments.forEach(function(treatment, idx) {
			if (treatment.selected) {
				treatment.$delete({}, function(data) {
					$scope.treatments = $scope.treatments.filter(function(treatment) {
						return treatment._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllersT2D.controller("NewTreatmentT2D", ["$scope", "$rootScope", "$modalInstance", "TreatmentT2D", "DefaultTreatmentT2D", "DefaultTreatmentSwitchT2D", "SwitchRiskFactorsT2D", function ($scope, $rootScope, $modalInstance, TreatmentT2D, DefaultTreatmentT2D, DefaultTreatmentSwitchT2D, SwitchRiskFactorsT2D) {
	$scope.strings = {
		"title":"New T2D treatment",
		"createButton":"Create new T2D treatment",
		"cancelButton":"Cancel"
	};
	
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	
	$scope.switchProperty = SwitchRiskFactorsT2D;
	
	$scope.switchEvent = "AMP";
	$scope.switchRiskFactor = "BMI";
	
	$scope.treatment = new TreatmentT2D(DefaultTreatmentT2D);
	$scope.treatment.creationDate = new Date().getTime();
	$scope.backVisible = false;

    $scope.removeSwitch = function(treatment) {
        if (treatment && treatment.switchCondition) {
            treatment.switchCondition = null;
        }
    }
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitchT2D);
		deepestTreatment.switchCondition.subsequentTreatment.depth = deepestTreatment.depth + 1;
	
		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};
	
	$scope.ok = function () {
		$modalInstance.close($scope.treatment);
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};
}]);

PRIMEControllersT2D.controller("EditTreatmentT2D", ["$scope", "$rootScope", "$routeParams", "$location", "TreatmentT2D", "DefaultTreatmentSwitchT2D", "SwitchRiskFactorsT2D", function($scope, $rootScope, $routeParams, $location, TreatmentT2D, DefaultTreatmentSwitchT2D, SwitchRiskFactorsT2D) {
	$scope.strings = {
		"title":"Treatment",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	};
	
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;
	
	$scope.switchProperty = SwitchRiskFactorsT2D;

	$scope.treatment = TreatmentT2D.get({treatmentId:$routeParams.id});
	$scope.backVisible = true;
  $scope.treatment.$promise.then(function(treatment) {
    $scope.readOnly = !treatment.owner;
  });
	
	$scope.removeSwitch = function(treatment) {
		if (treatment && treatment.switchCondition) {
			treatment.switchCondition = null;
		}
	}
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitchT2D);
		deepestTreatment.switchCondition.subsequentTreatment.depth = deepestTreatment.depth + 1;

		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo($(".switchable-container .condition-in-switchable-container").last(), 500, {offset: {left:0, top:0}});
		});
	};
	
	$scope.ok = function () {
		$scope.treatment.$update({}, function(data) {
			$location.path('/t2d/treatments');
		})
	};

	$scope.cancel = function () {
		$location.path('/t2d/treatments');
	};
}])

PRIMEControllersT2D.controller("EditTreatmentModalT2D", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "TreatmentT2D", "DefaultTreatmentSwitchT2D", "SwitchRiskFactorsT2D", "treatmentId", "treatments", "viewOnly", function($scope, $rootScope, $modalInstance, $routeParams, $location, TreatmentT2D, DefaultTreatmentSwitchT2D, SwitchRiskFactorsT2D, treatmentId, treatments, viewOnly) {
	$scope.strings = {
		"title":"Treatment",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	};
	
	$scope.findDeepestTreatment = function(treatment) {
		if (treatment.switchCondition !== null && treatment.switchCondition !== undefined) {
			return $scope.findDeepestTreatment(treatment.switchCondition.subsequentTreatment);
		} else {
			return treatment;
		}
	}
	$scope.hypoOptions = $rootScope.hypoOptions;

	$scope.switchProperty = SwitchRiskFactorsT2D;
	
	if (treatments !== null) {
		$scope.treatment = angular.copy(treatments.filter(function(treatment){
			return treatment._id === treatmentId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.treatment.owner;
  } else {
		$scope.treatment = TreatmentT2D.get({treatmentId:treatmentId});
    $scope.treatment.$promise.then(function(treatment) {
      $scope.readOnly =  viewOnly || !treatment.owner;
    });
	}

	$scope.removeSwitch = function(treatment) {
		if (treatment && treatment.switchCondition) {
			treatment.switchCondition = null;
		}
	}
	
	$scope.navigateToTreatment = function() {
		$(".switchable-container").scrollTo($(".subsequent-treatment").last(), 500);
	}
	
	$scope.addSwitch = function() {
		var deepestTreatment = $scope.findDeepestTreatment($scope.treatment);
		deepestTreatment.switchCondition = angular.copy(DefaultTreatmentSwitchT2D);
		deepestTreatment.switchCondition.subsequentTreatment.depth = deepestTreatment.depth + 1;
	
		$scope.$$postDigest(function() {
			$(".switchable-container").scrollTo({left:"933px", top:50}, 200);
		});
	};

	$scope.readOnly = !$scope.treatment.owner;
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.treatment); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);






// ===============================================
// Costs T2D
// ===============================================
PRIMEControllersT2D.controller("CostsT2D", ["$scope", "$location", "$modal", "$controller", "CostT2D", function ($scope, $location, $modal, $controller, CostT2D) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCost = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/cost-new.html?v=1.5.5",
			controller: "NewCostT2D",
			size: size,
			resolve: {
				costs: function () {
					return $scope.costs;
				}
			}
		});

		modalInstance.result.then(function (newCost) {
			newCost.$save({}, function(data) {
				$scope.costs.push(newCost);
				console.log("New cost created: ", newCost);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create cost modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCostModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/cost-new.html?v=1.5.5",
			controller: "EditCostModalT2D",
			size: size,
			resolve: {
				costs: function () { return $scope.costs; },
				costId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedCost) {
			editedCost.$update({}, function(data) {
				$scope.costs.filter(function(cost, index, costs) {
					if (cost._id === data._id) {
						costs[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit cost modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"Type 2 Costs",
		"search":"Search costs",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
    "share":"Share"
	}
	
	$scope.costs = CostT2D.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.costs, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.costs, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.costs.forEach(function(cost, idx) {
			if (cost.selected) {
				var duplicateCost = angular.copy(cost);
				delete cost.selected;

				delete duplicateCost._id;
				delete duplicateCost.selected;
				duplicateCost.sharedWith = [];
				duplicateCost.creationDate = new Date().getTime();
				duplicateCost.name = duplicateCost.name + " copy";
				duplicateCost.clonedFrom = cost._id;
				
				duplicateCost.$save({}, function(data) {
					$scope.costs.push(duplicateCost);
					if (options.modal) {
						$scope.editCostModal('lg', duplicateCost._id);
					} else {
						$location.path('/t2d/cost/' + duplicateCost._id);
					}
				})
			}
		})
	};

  $scope.shareSelected = function() {
    $scope.costs.forEach(function(cost) {
      if (cost.selected) {
        const id = cost._id;

        $modal.open({
          templateUrl: "partials/t2d/share-documents.html",
          controller: "ShareDocumentT2D",
          size: 'lg',
          resolve: {
            documentId: function () {
              return id;
            },
            collection: function () {
              return 'costs';
            }
          }
        });
      }});
  };
	
	$scope.deleteSelected = function() {
		$scope.costs.forEach(function(cost, idx) {
			if (cost.selected) {
				cost.$delete({}, function(data) {
					$scope.costs = $scope.costs.filter(function(cost) {
						return cost._id !== undefined;
					});
				})
			}
		})
	};
	
}]);

PRIMEControllersT2D.controller("NewCostT2D", ["$scope", "$modalInstance", "CostT2D", "DefaultCostT2D", "FeatureFlags", function ($scope, $modalInstance, CostT2D, DefaultCostT2D, FeatureFlags) {
	
	$scope.strings = {
		"title":"New T2D costs",
		"createButton":"Create new T2D costs",
		"cancelButton":"Cancel"
	}

	$scope.obesityMode = FeatureFlags.obesityMode;
	$scope.cost = new CostT2D(DefaultCostT2D);
	$scope.cost.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cost); };
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllersT2D.controller("EditCostT2D", ["$scope", "$routeParams", "$location", "CostT2D", "FeatureFlags", function($scope, $routeParams, $location, CostT2D, FeatureFlags) {
	$scope.strings = {
		"title":"Cost",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.obesityMode = FeatureFlags.obesityMode;

	$scope.cost = CostT2D.get({costId:$routeParams.id});
	$scope.backVisible = true;
  $scope.cost.$promise.then(function(cost) {
    $scope.readOnly = !cost.owner;
  });
	
	$scope.ok = function () {
		$scope.cost.$update({}, function(data) {
			$location.path('/t2d/costs');
		})
	};

	$scope.cancel = function () {
		$location.path('/t2d/costs');
	};
}])

PRIMEControllersT2D.controller("EditCostModalT2D", ["$scope", "$modalInstance", "$routeParams", "$location", "CostT2D", "costId", "costs", "viewOnly", "FeatureFlags", function($scope, $modalInstance, $routeParams, $location, CostT2D, costId, costs, viewOnly, FeatureFlags) {
	$scope.strings = {
		"title":"Cost",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}

	$scope.obesityMode = FeatureFlags.obesityMode;

	if (costs !== null) {
		$scope.cost = angular.copy(costs.filter(function(cost){
			return cost._id === costId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.cost.owner;
	} else {
		$scope.cost = CostT2D.get({costId:costId});
    $scope.cost.$promise.then(function(cost) {
      $scope.readOnly = viewOnly || !cost.owner;
    });
	}
	
	$scope.readOnly = !$scope.cost.owner;
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.cost); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);








// ===============================================
// Utilities T2D
// ===============================================
PRIMEControllersT2D.controller("UtilitiesT2D", ["$scope", "$rootScope", "$location", "$modal", "$controller", "UtilityT2D", function ($scope, $rootScope, $location, $modal, $controller, UtilityT2D) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newUtility = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/utility-new.html?v=1.5.5",
			controller: "NewUtilityT2D",
			size: size,
			resolve: {
				utilities: function () {
					return $scope.utilities;
				}
			}
		});

		modalInstance.result.then(function (newUtility) {
			newUtility.$save({}, function(data) {
        const option = $rootScope.qolCombinationOptionsT2D.find(function(option) {
          return option.id === newUtility.qoLApproach;
        });
        newUtility.qolApproachName = option ? option.name : "";
				$scope.utilities.push(newUtility);
				console.log("New utility created: ", newUtility);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create utility modal dismissed at: " + new Date());
		});
	}
	
	
	$scope.editUtilityModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/utility-new.html?v=1.5.5",
			controller: "EditUtilityModalT2D",
			size: size,
			resolve: {
				utilities: function () { return $scope.utilities; },
				utilityId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedUtility) {
			editedUtility.$update({}, function(data) {
				$scope.utilities.filter(function(utility, index, utilities) {
					if (utility._id === data._id) {
						utilities[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit utility modal dismissed at: " + new Date());
		});
	}
	
	$scope.strings = {
		"title":"Type 2 Utilities",
		"search":"Search utilities",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
    "share":"Share"
	}

	$scope.utilities = [];
	UtilityT2D.query().$promise.then(function(result) {
    $scope.utilities = result;
    $scope.utilities.forEach(function(utility) {
      const option = $rootScope.qolCombinationOptionsT2D.find(function(option) {
        return option.id === utility.qoLApproach;
      });
      utility.qolApproachName = option ? option.name : "";
    });
	});
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.utilities, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.utilities, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.utilities.forEach(function(utility, idx) {
			if (utility.selected) {
				var duplicateUtility = new UtilityT2D(angular.copy(utility));
				delete utility.selected;

				delete duplicateUtility._id;
				delete duplicateUtility.selected;
				duplicateUtility.sharedWith = [];
				duplicateUtility.creationDate = new Date().getTime();
				duplicateUtility.name = duplicateUtility.name + " copy";
				duplicateUtility.clonedFrom = utility._id;
				
				duplicateUtility.$save({}, function(data) {
					$scope.utilities.push(duplicateUtility);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateUtility._id);
					} else {
						$location.path('/t2d/utility/' + duplicateUtility._id);
					}
				})
			}
		})
	};

  $scope.shareSelected = function() {
    $scope.utilities.forEach(function(utility) {
      if (utility.selected) {
        const id = utility._id;

        $modal.open({
          templateUrl: "partials/t2d/share-documents.html",
          controller: "ShareDocumentT2D",
          size: 'lg',
          resolve: {
            documentId: function () {
              return id;
            },
            collection: function () {
              return 'utilities';
            }
          }
        });
      }});
  };
	
	$scope.deleteSelected = function() {
		$scope.utilities.forEach(function(utility, idx) {
			if (utility.selected) {
				utility.$delete({}, function(data) {
					$scope.utilities = $scope.utilities.filter(function(utility) {
						return utility._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllersT2D.controller("NewUtilityT2D", ["$scope", "$rootScope", "$modalInstance", "UtilityT2D", "DefaultUtilityT2D", "FeatureFlags", function ($scope, $rootScope, $modalInstance, UtilityT2D, DefaultUtilityT2D, FeatureFlags) {
	
	$scope.strings = {
		"title":"New T2D utility",
		"createButton":"Create new T2D utility",
		"cancelButton":"Cancel"
	}
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptionsT2D;
	$scope.obesityMode = FeatureFlags.obesityMode;

	$scope.utility = new UtilityT2D(DefaultUtilityT2D);
	$scope.utility.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.utility); };
	
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };

	// Validate SD for baseline QoL assuming Beta distribution
	// Valid when: sd >= 0 and sd < sqrt(mu * (1 - mu)), with 0 < mu < 1
	$scope.validateBetaSd = function() {
		// Access mean (mu) from the current utility
		const mu = $scope.utility.baselineQoL[0].mean;
    if (!mu && (mu <= 0)) { return; } // mean not set yet
		const field = $scope.newUtility.baselineQoLSd; // named input in the form
		if (!field) { return; }

		// If SD is empty/undefined, do not mark invalid (not required)
		const sd = $scope.utility.baselineQoL[0].sD;
    if (sd === undefined || sd === null || sd === "") {
			field.$setValidity('betaSd', true);
			return;
		}

		// Validate inputs
		var valid = false;
		if (mu > 0) {
			const limit = Math.sqrt(mu * (1 - mu));
			valid = (sd >= 0) && (sd < limit);
		}

		field.$setValidity('betaSd', !!valid);
	};

	// Re-validate SD when mean changes as well
	$scope._revalidateBaselineSd = function() {
		var sd = $scope.utility && $scope.utility.baselineQoL && $scope.utility.baselineQoL[0] ? $scope.utility.baselineQoL[0].sD : undefined;
		$scope.validateBetaSd(sd);
	};

	// Compute current max allowed SD for Beta distribution given baseline mean
	$scope.getBaselineSdMax = function() {
		var mu =$scope.utility.baselineQoL[0].mean;
		if (mu > 0) {
			return Math.sqrt(mu * (1 - mu));
		}
		return null;
	};

	// Nicely formatted label value (2 decimals) or 'N/A'
	$scope.getBaselineSdMaxLabel = function() {
		const max = $scope.getBaselineSdMax();
		return (max === null) ? 'N/A' : '< ' + max.toFixed(3);
	};
	
}]);

PRIMEControllersT2D.controller("EditUtilityT2D", ["$scope", "$rootScope", "$routeParams", "$location", "UtilityT2D", "FeatureFlags", function($scope, $rootScope, $routeParams, $location, UtilityT2D, FeatureFlags) {
	$scope.strings = {
		"title":"Utility",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.obesityMode = FeatureFlags.obesityMode;
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptionsT2D;
	$scope.utility = UtilityT2D.get({utilityId:$routeParams.id});
	$scope.backVisible = true;
  $scope.utility.$promise.then(function(utility) {
    $scope.readOnly = !utility.owner;
  });
	
	$scope.ok = function () {
		$scope.utility.$update({}, function(data) {
			$location.path('/t2d/utilities');
		})
	};

	$scope.cancel = function () {
		$location.path('/t2d/utilities');
	};

	// --- Baseline SD Beta validation & helpers (mirrors NewUtilityT2D) ---
	// Validate SD for baseline QoL assuming Beta distribution
	// Valid when: sd >= 0 and sd < sqrt(mu * (1 - mu)), with 0 < mu < 1
	$scope.validateBetaSd = function() {
		// Access mean (mu) from the current utility
		const mu = $scope.utility && $scope.utility.baselineQoL && $scope.utility.baselineQoL[0] ? $scope.utility.baselineQoL[0].mean : undefined;
		if (!(typeof mu === 'number') || !(mu > 0 && mu < 1)) { return; }

		// The edit form name is likely different; try both known forms
		const field = ($scope.editUtility && $scope.editUtility.baselineQoLSd) || ($scope.newUtility && $scope.newUtility.baselineQoLSd);
		if (!field) { return; }

		// If SD is empty/undefined, do not mark invalid (not required)
		const sd = $scope.utility && $scope.utility.baselineQoL && $scope.utility.baselineQoL[0] ? $scope.utility.baselineQoL[0].sD : undefined;
		if (sd === undefined || sd === null || sd === "") {
			field.$setValidity('betaSd', true);
			return;
		}

		// Validate inputs
		let valid = false;
		if (typeof sd === 'number' && !isNaN(sd)) {
			const limit = Math.sqrt(mu * (1 - mu));
			valid = (sd >= 0) && (sd < limit);
		}

		field.$setValidity('betaSd', !!valid);
	};

	// Re-validate SD when mean changes as well
	$scope._revalidateBaselineSd = function() {
		$scope.validateBetaSd();
	};

	// Compute current max allowed SD for Beta distribution given baseline mean
	$scope.getBaselineSdMax = function() {
		const mu = $scope.utility && $scope.utility.baselineQoL && $scope.utility.baselineQoL[0] ? $scope.utility.baselineQoL[0].mean : undefined;
		if (typeof mu === 'number' && !isNaN(mu) && mu > 0 && mu < 1) {
			return Math.sqrt(mu * (1 - mu));
		}
		return null;
	};

	// Nicely formatted label value (2 decimals) or 'N/A'
	$scope.getBaselineSdMaxLabel = function() {
		const max = $scope.getBaselineSdMax();
		return (max === null) ? 'N/A' : '< ' + max.toFixed(3);
	};
}])

PRIMEControllersT2D.controller("EditUtilityModalT2D", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "UtilityT2D", "utilityId", "utilities", "viewOnly", "FeatureFlags", function($scope, $rootScope, $modalInstance, $routeParams, $location, UtilityT2D, utilityId, utilities, viewOnly, FeatureFlags) {
	$scope.strings = {
		"title":"Utility",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}

	$scope.obesityMode = FeatureFlags.obesityMode;
	$scope.qolCombinationOptions = $rootScope.qolCombinationOptionsT2D;
	
	if (utilities !== null) {
		$scope.utility = angular.copy(utilities.filter(function(utility){
			return utility._id === utilityId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.utility.owner;
	} else {
		$scope.utility = UtilityT2D.get({utilityId:utilityId});
    $scope.utility.$promise.then(function(utility) {
      $scope.readOnly = viewOnly || !utility.owner;
    });
	}

  $scope.readOnly = !$scope.utility.owner;
	
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.utility); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);












// ===============================================
// Countries T2D
// ===============================================
PRIMEControllersT2D.controller("CountriesT2D", ["$scope", "$location", "$modal", "$controller", "CountryT2D", function ($scope, $location, $modal, $controller, CountryT2D) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newCountry = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/country-new.html",
			controller: "NewCountryT2D",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; }
			}
		});

		modalInstance.result.then(function (newCountry) {
			newCountry.$save({}, function(data) {
				$scope.countries.push(newCountry);
				console.log("New country created: ", newCountry);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create country modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCountryModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/country-new.html?v1.0.10",
			controller: "EditCountryModalT2D",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; },
				countryId: function() { return id; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedCountry) {
			editedCountry.$update({}, function(data) {
				$scope.countries.filter(function(country, index, countries) {
					if (country._id === data._id) {
						countries[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
		});
	}
	
	
	$scope.strings = {
		"title":"Type 2 Countries",
		"search":"Search countries",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
    "share":"Share"
	}
	
	$scope.countries = CountryT2D.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.countries, function(value){
			if (value.selected) count++;
		});
		return count;
	}

  $scope.hasOwnership = function() {
    let owner = true;
    angular.forEach($scope.countries, function(value){
      if (value.selected && !value.owner) owner = false;
    });

    return owner;
  }
	
	$scope.cloneSelected = function(options) {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				var duplicateCountry = angular.copy(country);
				delete country.selected;

				delete duplicateCountry._id;
				delete duplicateCountry.selected;
				duplicateCountry.sharedWith = [];
				duplicateCountry.creationDate = new Date().getTime();
				duplicateCountry.name = duplicateCountry.name + " copy";
				duplicateCountry.clonedFrom = country._id;
				
				duplicateCountry.$save({}, function(data) {
					$scope.countries.push(duplicateCountry);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateCountry._id);
					} else {
						$location.path('/t2d/country/' + duplicateCountry._id);
					}
				})
			}
		})
	}

  $scope.shareSelected = function() {
    $scope.countries.forEach(function(country) {
      if (country.selected) {
        const id = country._id;

        $modal.open({
          templateUrl: "partials/t2d/share-documents.html",
          controller: "ShareDocumentT2D",
          size: 'lg',
          resolve: {
            documentId: function () {
              return id;
            },
            collection: function () {
              return 'countries';
            }
          }
        });
      }});
  };
	
	$scope.deleteSelected = function() {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				country.$delete({}, function(data) {
					$scope.countries = $scope.countries.filter(function(country) {
						return country._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllersT2D.controller("NewCountryT2D", ["$scope", "$rootScope", "$modalInstance", "CountryT2D", "DefaultCountryT2D", "LifeTableT2D", function ($scope, $rootScope, $modalInstance, CountryT2D, DefaultCountry, LifeTableT2D) {
	
	$scope.strings = {
		"title":"New T2D country",
		"createButton":"Create new T2D country",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDT2DModelAveragingOptions;
	
	$scope.lifetables = LifeTableT2D.query();
	$scope.country = new CountryT2D(DefaultCountry);
	$scope.country.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllersT2D.controller("EditCountryT2D", ["$scope", "$rootScope", "$routeParams", "$location", "CountryT2D", "LifeTableT2D", function($scope, $rootScope, $routeParams, $location, CountryT2D, LifeTableT2D) {
	$scope.strings = {
		"title":"Country T2D",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDT2DModelAveragingOptions;
	
	$scope.lifetables = LifeTableT2D.query();
	$scope.country = CountryT2D.get({countryId:$routeParams.id});
	$scope.backVisible = true;
  $scope.country.$promise.then(function(country) {
    $scope.readOnly = !country.owner;
  });
	
	$scope.ok = function () {
		$scope.country.$update({}, function(data) {
			$location.path('/t2d/countries');
		})
	};

	$scope.cancel = function () {
		$location.path('/t2d/countries');
	};
}])

PRIMEControllersT2D.controller("EditCountryModalT2D", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "CountryT2D", "countryId", "countries", "LifeTableT2D", "viewOnly", function($scope, $rootScope, $modalInstance, $routeParams, $location, CountryT2D, countryId, countries, LifeTableT2D, viewOnly) {
	$scope.strings = {
		"title":"Country T2D",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDT2DModelAveragingOptions;

  $scope.lifetables = LifeTableT2D.query();

	if (countries !== null) {
		$scope.country = angular.copy(countries.filter(function(country){
			return country._id === countryId;
		})[0]);
    $scope.readOnly = viewOnly || !$scope.country.owner;
	} else {
    $scope.country = CountryT2D.get({countryId:countryId});
    $scope.country.$promise.then(function(country) {
      $scope.readOnly = viewOnly || !country.owner;
    });
  }

  $scope.readOnly = !$scope.country.owner;

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);






PRIMEControllersT2D.controller("SensitivityAnalysesT2D", ["$scope", "$location", "$modal", "$controller", "CountryT2D", function ($scope, $location, $modal, $controller, CountryT2D) {
	
	$controller("TabPaneController", {$scope: $scope});
	
	$scope.configureAsTabPane();
	
	$scope.predicate = 'creationDate';
	$scope.reverse = true;
	
	$scope.newOWSA = function(size) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/owsa-new.html",
			controller: "NewSensitivityAnalysisT2D",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; }
			}
		});

		modalInstance.result.then(function (newCountry) {
			newCountry.$save({}, function(data) {
				$scope.countries.push(newCountry);
				console.log("New OWSA created: ", newCountry);
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function () {
			console.log("Create OWSA modal dismissed at: " + new Date());
		});
	}
	
	$scope.editCountryModal = function(size, id) {
		var modalInstance = $modal.open({
			templateUrl: "partials/t2d/owsa-new.html",
			controller: "EditSensitivityAnalysisModalT2D",
			size: size,
			resolve: {
				countries: function () { return $scope.countries; },
				countryId: function() { return id; },
				readOnly: function() { return false; },
				lifetables: function() { return $scope.lifetables; },
        viewOnly: function () { return false; }
			}
		});

		modalInstance.result.then(function (editedCountry) {
			editedCountry.$update({}, function(data) {
				$scope.countries.filter(function(country, index, countries) {
					if (country._id === data._id) {
						countries[index] = data;
					}
				});
			}, function(err) {
				console.log("A database error occurred.");
			});
		}, function (reason) {
			console.log("Edit OWSA modal dismissed at: " + new Date());
		});
	}
	
	
	$scope.strings = {
		"title":"Type 2 Sensitivity Analyses",
		"search":"Search sensitivity analyses",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate"
	}
	
	$scope.countries = CountryT2D.query();
	
	$scope.selectedItems = function() {
		var count = 0;
		angular.forEach($scope.countries, function(value){
			if (value.selected) count++;
		});
		return count;
	}
	
	$scope.cloneSelected = function(options) {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				var duplicateCountry = angular.copy(country);
				delete country.selected;

				delete duplicateCountry._id;
				delete duplicateCountry.selected;
				duplicateCountry.sharedWith = [];
				duplicateCountry.creationDate = new Date().getTime();
				duplicateCountry.name = duplicateCountry.name + " copy";
				duplicateCountry.clonedFrom = country._id;
				
				duplicateCountry.$save({}, function(data) {
					$scope.countries.push(duplicateCountry);
					if (options.modal) {
						$scope.editUtilityModal('lg', duplicateCountry._id);
					} else {
						$location.path('/t2d/country/' + duplicateCountry._id);
					}
				})
			}
		})
	}
	
	$scope.deleteSelected = function() {
		$scope.countries.forEach(function(country, idx) {
			if (country.selected) {
				country.$delete({}, function(data) {
					$scope.countries = $scope.countries.filter(function(country) {
						return country._id !== undefined;
					});
				})
			}
		})
	};
}]);

PRIMEControllersT2D.controller("NewSensitivityAnalysisT2D", ["$scope", "$rootScope", "$modalInstance", "CountryT2D", "DefaultCountryT2D", function ($scope, $rootScope, $modalInstance, CountryT2D, DefaultCountry) {
	
	$scope.strings = {
		"title":"New T2D sensitivity analyses",
		"createButton":"Create new T2D sensitivity analyses",
		"cancelButton":"Cancel"
	}
	
	$scope.country = new CountryT2D(DefaultCountry);
	$scope.country.creationDate = new Date().getTime();
	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
	
}]);

PRIMEControllersT2D.controller("EditSensitivityAnalysisT2D", ["$scope", "$rootScope", "$routeParams", "$location", "CountryT2D", "LifeTableT2D", function($scope, $rootScope, $routeParams, $location, CountryT2D, LifeTableT2D) {
	$scope.strings = {
		"title":"Sensitivity analyses T2D",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDT2DModelAveragingOptions;
	
	$scope.lifetables = LifeTableT2D.query();
	$scope.country = CountryT2D.get({countryId:$routeParams.id});
	$scope.backVisible = true;
	
	$scope.ok = function () {
		$scope.country.$update({}, function(data) {
			$location.path('/t2d/countries');
		})
	};

	$scope.cancel = function () {
		$location.path('/t2d/countries');
	};
}])

PRIMEControllersT2D.controller("EditSensitivityAnalysisModalT2D", ["$scope", "$rootScope", "$modalInstance", "$routeParams", "$location", "CountryT2D", "countryId", "countries", "lifetables", "readOnly", function($scope, $rootScope, $modalInstance, $routeParams, $location, CountryT2D, countryId, countries, lifetables, readOnly) {
	$scope.strings = {
		"title":"Sensitivity analyses T2D",
		"createButton":"Save changes",
		"cancelButton":"Cancel"
	}
	$scope.cVDModelAveragingOptions = $rootScope.cVDT2DModelAveragingOptions;
	
	$scope.lifetables = lifetables;
	
	if (countries !== null) {
		$scope.country = angular.copy(countries.filter(function(country){
			return country._id === countryId;
		})[0]);		
	} else {
		$scope.country = CountryT2D.get({countryId:countryId});
	}
	
	$scope.readOnly = readOnly;

	$scope.backVisible = false;
	
	$scope.ok = function () { $modalInstance.close($scope.country); };
	$scope.cancel = function () { $modalInstance.dismiss('cancel'); };
}]);








// ===============================================
// Simulations T2D
// ===============================================
PRIMEControllersT2D.controller("SimulationsT2D", ["$scope", "$window", "$routeParams", "$location", "$timeout", "$modal", "SimulationServiceT2D", "ICERCalculatorT2D", "Stats", "QueueServiceT2D", "$http", function ($scope, $window, $routeParams, $location, $timeout, $modal, SimulationServiceT2D, ICERCalculatorT2D, Stats, QueueServiceT2D, $http) {
	$scope.strings = {
		"title":"Type 2 Simulations",
		"searchSimulations":"Search simulations",
		"new":"New",
		"delete":"Delete",
		"clone":"Duplicate",
    "share":"Share",
		"rerun":"Rerun",
		"export":"Export to Excel"
	}

  // UI state
  $scope.query     = "";     // bound to input
  $scope.page      = 1;
  $scope.pageSize  = 20;
  $scope.total     = 0;
  $scope.totalPages = 1;
  $scope.loading   = false;
  $scope.errorMsg  = null;

  // current page data
  $scope.paged = { items: [] }; // {items, page, pageSize, total, totalPages}

  $scope.icer = ICERCalculatorT2D.icer;

  $scope.newSimulation = function() { $location.path("/t2d/simulations/new"); };

  // queue polling (unchanged)
  $scope.queueLength = '';
  (function tick() {
    QueueServiceT2D.get(function(model) {
      $scope.queueLength = model;
      $timeout(tick, 40000);
    });
  })();

  // ---- pagination + search ----
  let searchDebounce;
  $scope.loadPage = function(page, opts) {
    opts = opts || {};
    if (page) $scope.page = page;
    if ($scope.loading  && !opts.force) return;          // prevent double-click spam
    $scope.loading = true;
    $scope.errorMsg = null;

    const params = {
      page: $scope.page,
      pageSize: $scope.pageSize,
      search: $scope.query || undefined
    };

    // IMPORTANT: use $promise so we can .finally()
    SimulationServiceT2D.queryPaged(params).$promise
      .then(function(res){
        (res.items || []).forEach(function(it){ it.selected = !!it.selected; });
        $scope.paged = res;
        $scope.total = res.total || 0;
        $scope.totalPages = res.totalPages || 1;
      })
      .catch(function(err){
        $scope.paged = { items: [] };
        $scope.total = 0;
        $scope.totalPages = 1;
        $scope.errorMsg = 'Failed to load simulations.';
        console.error(err);
      })
      .finally(function(){
        $scope.loading = false;
      });
  };

  // initial load
  $scope.loadPage(1);

  // debounce search input → restart from page 1
  $scope.$watch("query", function() {
    if (searchDebounce) $timeout.cancel(searchDebounce);
    searchDebounce = $timeout(function(){
      $scope.page = 1;
      $scope.loadPage(1);
    }, 300);
  });

  // selection helpers (work on current page)
  $scope.selectedItems = function() {
    var count = 0;
    angular.forEach($scope.paged.items, function(v){ if (v.selected) count++; });
    return count;
  };
  $scope.hasOwnership = function() {
    var owner = true;
    angular.forEach($scope.paged.items, function(v){ if (v.selected && !v.owner) owner = false; });
    return owner;
  };

  // actions
  $scope.cloneSelected = function() {
    $scope.paged.items.forEach(function(sim){ if (sim.selected) $location.path('/t2d/simulations/new/' + sim._id); });
  };
  $scope.shareSelected = function() {
    const id = $scope.paged.items
      .filter(function (sim) { return sim.selected; })
      .map(function (sim) { return sim._id; })[0];

    $modal.open({
      templateUrl: "partials/t2d/share-documents.html",
      controller: "ShareDocumentT2D",
      size: 'lg',
      resolve: {
        documentId: function() { return id; },
        collection: function () { return 'simulations'; }
      }
    });
  };
  $scope.deleteSelected = function () {
    if ($scope.loading) return;

    var ids = $scope.paged.items
      .filter(function (sim) { return sim.selected; })
      .map(function (sim) { return sim._id; });

    if (!ids.length) return;
    if (!$window.confirm('Delete ' + ids.length + ' simulation(s)?')) return;

    $scope.loading = true;
    var remaining = ids.length;

    var allSelectedOnPage = $scope.paged.items.every(function (it) { return it.selected; });
    var targetPage = (allSelectedOnPage && $scope.page > 1) ? ($scope.page - 1) : $scope.page;

    ids.forEach(function (id) {
      SimulationServiceT2D.delete({ simulationId: id }).$promise
        .catch(function (err) { console.error('Delete failed for', id, err); })
        .finally(function () {
          if (--remaining === 0) $scope.loadPage(targetPage, { force: true });
        });
    });
  };
  $scope.rerunSelected = function () {
    var ids = $scope.paged.items
      .filter(function (sim) { return sim.selected; })
      .map(function (sim) { return sim._id; });

    if (!ids.length) return;
    if (!$window.confirm('Rerun ' + ids.length + ' simulation(s)?')) return;

    var remaining = ids.length;

    ids.forEach(function (id) {
      SimulationServiceT2D.rerun({ simulationId: id }).$promise
        .catch(function (err) {
          // optional: surface a toast / message
          console.error('Rerun failed for', id, err);
        })
        .finally(function () {
          // Backend updates progress/status → just refresh this page
          $scope.loadPage($scope.page);
        });
    });
  };
  $scope.includeCohorts = false;
  $scope.exportSelected = function() {
    var ids = [];
    $scope.paged.items.forEach(function(sim){ if (sim.selected) ids.push(sim._id); });
    if (!ids.length) return;

		let path = '/api/t2d/simulations/batchexport';
		if ($scope.advanced && $scope.includeCohorts) {
			path += "?includeCohorts=true";
		}

    $http.post(path, {ids: ids}).then(function(res) {
      $modal.open({
        templateUrl: "partials/t2d/export-modal.html?v=2.3.8",
        controller: "ExportT2D",
        size: 'sm',
        resolve: {
          jobId: function() { return res.data.jobId; }
        }
      });
    });
  };
}]);

PRIMEControllersT2D.controller("SimulationT2D", ["$scope", "$interval", "$window", "$rootScope", "$routeParams", "$location", "$modal", "SimulationServiceT2D", "LifeTableT2D", "ICERCalculatorT2D", "Stats", "$http", "FeatureFlags", function ($scope, $interval, $window, $rootScope, $routeParams, $location, $modal, SimulationServiceT2D, LifeTableT2D, ICERCalculatorT2D, Stats, $http, FeatureFlags) {
	$scope.strings = {
		"title":"Simulation",
		"clone":"Duplicate",
		"excelExport":"Export to Excel",
		"animate":"Animate",
		"stop":"Stop"
	}
	$scope.obesityMode = FeatureFlags.obesityMode;
	$scope.icer = ICERCalculatorT2D.icer;
	
	$scope.clone = function() {
		$location.path('/t2d/simulations/new/' + $scope.results._id);
	}
	
	$scope.export = function() {
		let path = '/api/t2d/simulations/batchexport';
		if ($scope.advanced && $scope.includeCohorts) {
			path += "?includeCohorts=true";
		}
		$http.post(path, {ids: [$scope.results._id]}).then(function(res) {
			$modal.open({
				templateUrl: "partials/t2d/export-modal.html?v=2.3.7",
				controller: "ExportT2D",
				size: 'sm',
				resolve: {
					jobId: function() { return res.data.jobId; }
				}
			});
		});
	}
	
	$scope.scenario1Name = "Intervention";
  $scope.scenario2Name = "Comparator";

	$scope.animating = false;
	
	$scope.apiUrlOption = {
		method: "GET",
		responseInterceptor : function (response) {
			response.data = response.data.map(function(user) {
				return user.email;
			});
		}
	};
	
	$scope.options = {
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					if (typeof tooltipItem.yLabel === "string") {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toFixed(2);
					} else {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(2);
					}
				}
			}
		},
		legend: {
			display: true
		},
		scales: {
			xAxes: [{
				ticks: {
					maxTicksLimit: 10,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				ticks: {
					min:0
				},
        scaleLabel: {
          display: true,
          labelString: ''
        }
			}]
		},
		elements: {
			line: {
				fill: false
			}
		}
	};
	$scope.renalStackedOptions = {
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);
				}
			}
		},
		legend: { 
			display: true
		},
		scales: {
			xAxes: [{
				ticks: {
					maxTicksLimit: 10,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				stacked: true,
				ticks: {
					min:0
				}
			}]
		},
		elements: {
			line: {
				fill: true
			}
		}
	}
	$scope.cvdStackedOptions = angular.copy($scope.renalStackedOptions);
	$scope.cvdStackedOptions.scales.yAxes[0].stacked = false;
	$scope.cvdStackedOptions.elements.line.fill = false;
	
	$scope.costOptions = angular.copy($scope.renalStackedOptions);
	$scope.costOptions.scales.xAxes[0].stacked = true;
	$scope.costOptions.tooltips.callbacks.label = function(tooltipItem, data) {
		return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(0);
	}
	$scope.costOptions.scales.yAxes[0].stacked = true;
	
	$scope.qolOptions = angular.copy($scope.renalStackedOptions);
	delete $scope.qolOptions.scales.yAxes[0].ticks.min;
	
	$scope.treatmentLineOptions = {
		type: 'bar',
		segmentShowStroke: false,
		borderWidth: 0,
		aspectRatio: 1.6,
		tooltips: {
			callbacks: {
				label: function(tooltipItem, data) {
					return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);
				}
			}
		},
		legend: { 
			display: true
		},
		scales: {
			xAxes: [{
				stacked: true,
				ticks: {
					maxTicksLimit: 50,
					maxRotation: 0,
					minRotation: 0
				},
				scaleLabel: {
					display: true,
					labelString: 'Time (years)'
				}
			}],
			yAxes: [{
				stacked: true,
				offset: false,
				ticks: {
					beginAtZero: true,
					max:100,
					min:0
				}
			}]
		},
		elements: {
			line: {
				fill: true
			}
		}
	}
	
	$scope.simulations = SimulationServiceT2D.get({simulationId:$routeParams.id});
	
	$scope.show = function(size, id, elementType) {
		switch (elementType) {
		case "cohorts":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/t2d/cohort-new.html?v=1.5.5",
				controller: "EditCohortModalT2D",
				size: size,
				resolve: {
					cohorts: function () { return null; },
					cohortId: function() { return id; },
          viewOnly: function() { return true;  }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "treatments":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/t2d/treatment-new.html?v=1.3.7",
				controller: "EditTreatmentModalT2D",
				size: size,
				resolve: {
					treatments: function () { return null; },
					treatmentId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "costs":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/t2d/cost-new.html?v=1.5.5",
				controller: "EditCostModalT2D",
				size: size,
				resolve: {
					costs: function () { return null; },
					costId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "utilities":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/t2d/utility-new.html?v=1.5.5",
				controller: "EditUtilityModalT2D",
				size: size,
				resolve: {
					utilities: function () { return null; },
					utilityId: function() { return id; },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		case "countries":
			$scope.modalInstance = $modal.open({
				templateUrl: "partials/t2d/country-new.html?v1.0.10",
				controller: "EditCountryModalT2D",
				size: size,
				resolve: {
					countries: function () { return null; },
					countryId: function() { return id; },
					lifetables: function() {return LifeTableT2D.query(); },
          viewOnly: function () { return true; }
				}
			});
			$scope.modalInstance.result.then(function () {}, function () {});
			break;
		}
	}

	$rootScope.pluralMap = {
		cohorts:    { '0':'Cohorts',  'one':'Cohort',  'other':'Cohorts' },
		treatments: { '0':'Treatments','one':'Treatment','other':'Treatments' },
		costs:      { '0':'Costs',    'one':'Cost',    'other':'Costs' },
		utilities:  { '0':'Utilities','one':'Utility', 'other':'Utilities' },
		countries:  { '0':'Countries','one':'Country', 'other':'Countries' }
	};
	
	$scope.simulations.$promise.then(function(data) {
		$scope.results = data;
		$scope.hasObesity = !!($scope.obesityMode && data.arms && data.arms['0'] && (
			(data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime && data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime.length > 0) ||
			(data.arms['0'].cumulativeIncidenceChronicLowerBackPain && data.arms['0'].cumulativeIncidenceChronicLowerBackPain.length > 0) ||
			(data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime && data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime.length > 0)
		));
		$scope.labels = [];
		for (var i = 0; i <= data.timeHorizon; i++) {
			$scope.labels.push(i);
		}
		for (var element in $scope.results.fullElements) {
			if (!$scope.results.fullElements.hasOwnProperty(element)) continue;
			$scope.results.fullElements[element].pluralize = ($rootScope.pluralMap || {})[element];
		}

    $scope.twoLineColors = [
      { backgroundColor: '#f6d4c9', borderColor: '#f74902', pointBackgroundColor: '#f74902', hoverBackgroundColor: '#f6d4c9', hoverBorderColor: '#f74902', pointHoverBackgroundColor: '#f6d4c9', pointHoverBorderColor: '#f74902' },
      { backgroundColor: '#e2e2e2', borderColor: '#999999', pointBackgroundColor: '#999999', hoverBackgroundColor: '#e2e2e2', hoverBorderColor: '#999999', pointHoverBackgroundColor: '#e2e2e2', pointHoverBorderColor: '#999999' },
    ];
		$scope.series = [$scope.scenario1Name, $scope.scenario2Name];
		$scope.survivalCurves = [data.arms['1'].survivalOverTime, data.arms['0'].survivalOverTime];
    $scope.survivalOptions = angular.copy($scope.options);
    $scope.survivalOptions.scales.yAxes[0].scaleLabel.labelString = "Proportion alive";
		$scope.hbA1cCurves = [data.arms['1'].meanHbA1cOverTime, data.arms['0'].meanHbA1cOverTime];
    $scope.hbA1cOptions = angular.copy($scope.options);
    $scope.hbA1cOptions.scales.yAxes[0].scaleLabel.labelString = "HbA1c (%)";
		$scope.sBPCurves = [data.arms['1'].meanSBPOverTime, data.arms['0'].meanSBPOverTime];
    $scope.sBPOptions = angular.copy($scope.options);
    $scope.sBPOptions.scales.yAxes[0].scaleLabel.labelString = "SBP (mmHg)";
		$scope.bMICurves = [data.arms['1'].meanBMIOverTime, data.arms['0'].meanBMIOverTime];
    $scope.bMIOptions = angular.copy($scope.options);
    $scope.bMIOptions.scales.yAxes[0].scaleLabel.labelString = "BMI (kg/m\u00B2)";
		$scope.eGFRCurves = [data.arms['1'].meaneGFROverTime, data.arms['0'].meaneGFROverTime];
    $scope.eGFROptions = angular.copy($scope.options);
    $scope.eGFROptions.scales.yAxes[0].scaleLabel.labelString = "eGFR (mL/min/1.73m\u00B2)";
		$scope.hBCurves = [data.arms['1'].meanHaemOverTime, data.arms['0'].meanHaemOverTime];
    $scope.hBOptions = angular.copy($scope.options);
    $scope.hBOptions.scales.yAxes[0].scaleLabel.labelString = "Hemoglobin (g/dL)";
		$scope.wBCCurves = [data.arms['1'].meanwBCOverTime, data.arms['0'].meanwBCOverTime];
    $scope.wBCOptions = angular.copy($scope.options);
    $scope.wBCOptions.scales.yAxes[0].scaleLabel.labelString = "WBC count (10\u2076" + " cells/mL)";
		$scope.ldlCholesterolCurves = [data.arms['1'].meanLDLOverTime, data.arms['0'].meanLDLOverTime];
    $scope.ldlOptions = angular.copy($scope.options);
    $scope.ldlOptions.scales.yAxes[0].scaleLabel.labelString = "LDL cholesterol (mmol/L)";
		$scope.hdlCholesterolCurves = [data.arms['1'].meanHDLOverTime, data.arms['0'].meanHDLOverTime];
    $scope.hdlOptions = angular.copy($scope.options);
    $scope.hdlOptions.scales.yAxes[0].scaleLabel.labelString = "HDL cholesterol (mmol/L)";
		$scope.severeHypoglycemia = [data.arms['1'].severeHypoRatesOverTime, data.arms['0'].severeHypoRatesOverTime];
		$scope.nonSevereHypoglycemia =
      [
        data.arms['1'].nonSevereDaytimeHypoRatesOverTime.map((dt, i) => dt + data.arms[1].nonSevereNocturnalHypoRatesOverTime[i]),
        data.arms['0'].nonSevereDaytimeHypoRatesOverTime.map((dt, i) => dt + data.arms[0].nonSevereNocturnalHypoRatesOverTime[i])
      ];
		
		$scope.discountedCostBreakdown = true;
		($scope.recalcCostBreakdown = function() {
			if (data.arms['0'].costsOverTime !== undefined) {
			
				$scope.cvdCost = [0],
				$scope.renalCosts = [0],
				$scope.treatmentsCost = [0],
				$scope.adverseEventCost = [0],
				$scope.ocularCost = [0],
				$scope.otherCost = [0],
				$scope.neuropathyAmpCost = [0],
				$scope.cvdCost2 = [0],
				$scope.renalCosts2 = [0],
				$scope.treatmentsCost2 = [0],
				$scope.adverseEventCost2 = [0],
				$scope.ocularCost2 = [0],
				$scope.otherCost2 = [0],
				$scope.neuropathyAmpCost2 = [0],
				$scope.miCost1 = [0],
				$scope.strokeCost1 = [0],
				$scope.anginaCost1 = [0],
				$scope.revascCost1 = [0],
				$scope.chfCost1 = [0],
				$scope.retinopathyCost1 = [0],
				$scope.meCost1 = [0],
				$scope.neuropathyCost1 = [0],
				$scope.amputationCost1 = [0],
				$scope.ulcerCost1 = [0],
				$scope.renalCost1 = [0],
				$scope.esrdCost1 = [0],
				$scope.hypoglycemiaCost1 = [0],
				$scope.treatmentCost1 = [0],
				$scope.concomitantCost1 = [0],
				$scope.indirectCost1 = [0],
				$scope.compFreeCost1 = [0],
				$scope.unrelatedMedCost1 = [0],
				$scope.miCost2 = [0],
				$scope.strokeCost2 = [0],
				$scope.anginaCost2 = [0],
				$scope.revascCost2 = [0],
				$scope.chfCost2 = [0],
				$scope.retinopathyCost2 = [0],
				$scope.meCost2 = [0],
				$scope.neuropathyCost2 = [0],
				$scope.amputationCost2 = [0],
				$scope.ulcerCost2 = [0],
				$scope.renalCost2 = [0],
				$scope.esrdCost2 = [0],
				$scope.hypoglycemiaCost2 = [0],
				$scope.treatmentCost2 = [0],
				$scope.concomitantCost2 = [0],
				$scope.indirectCost2 = [0],
				$scope.compFreeCost2 = [0],
				$scope.unrelatedMedCost2 = [0],
				$scope.clbpCost2 = [0],
				$scope.clbpCost1 = [0],
				$scope.koaCost2 = [0],
				$scope.koaCost1 = [0],
				$scope.postTkrCost2 = [0],
				$scope.postTkrCost1 = [0],
				$scope.steatosisF0F2Cost2 = [0],
				$scope.steatosisF0F2Cost1 = [0],
				$scope.steatosisF3Cost2 = [0],
				$scope.steatosisF3Cost1 = [0],
				$scope.compensatedCirrhosisCost2 = [0],
				$scope.compensatedCirrhosisCost1 = [0],
				$scope.dccAndHccCost2 = [0],
				$scope.dccAndHccCost1 = [0],
				$scope.liverTransplantCost2 = [0],
				$scope.liverTransplantCost1 = [0],
				$scope.postLiverTransplantCost2 = [0],
				$scope.postLiverTransplantCost1 = [0]
				;
			
				var disc1 = $scope.discountedCostBreakdown ? (1 + data.fullElements.countries[0].costDiscountRate / 100) : 1,
					disc2 = $scope.discountedCostBreakdown ? (data.fullElements.countries.length > 1 ? (1 + data.fullElements.countries[1].costDiscountRate / 100) : (1 + data.fullElements.countries[0].costDiscountRate / 100)) : 1;
				
				Object.keys(data.arms['0'].costsOverTime).forEach(function(key) {
					Object.keys(data.arms['0'].costsOverTime[key].stateProportionMap).forEach(function(costCategory) {
						switch (costCategory) {
							case "AMP": // neuropathyAmpCost
								$scope.neuropathyAmpCost.push($scope.neuropathyAmpCost[$scope.neuropathyAmpCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['NEURO'] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['ULCER'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyAmpCost2.push($scope.neuropathyAmpCost2[$scope.neuropathyAmpCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['NEURO'] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['ULCER'] * 1 / Math.pow(disc1, parseInt(key) - 1));
							
								$scope.amputationCost1.push($scope.amputationCost1[$scope.amputationCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.amputationCost2.push($scope.amputationCost2[$scope.amputationCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "IHD": // cvdCost
								$scope.cvdCost.push($scope.cvdCost[$scope.cvdCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['CHF'] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['MI'] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['STROKE'] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['REVASC'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.cvdCost2.push($scope.cvdCost2[$scope.cvdCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['CHF'] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['MI'] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['STROKE'] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['REVASC'] * 1 / Math.pow(disc1, parseInt(key) - 1))
							
								$scope.anginaCost1.push($scope.anginaCost1[$scope.anginaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.anginaCost2.push($scope.anginaCost2[$scope.anginaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CHF": // cvdCost
								$scope.chfCost1.push($scope.chfCost1[$scope.chfCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.chfCost2.push($scope.chfCost2[$scope.chfCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "HYPO":
								$scope.hypoglycemiaCost1.push($scope.hypoglycemiaCost1[$scope.hypoglycemiaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.hypoglycemiaCost2.push($scope.hypoglycemiaCost2[$scope.hypoglycemiaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "MI": // cvdCost
								$scope.miCost1.push($scope.miCost1[$scope.miCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.miCost2.push($scope.miCost2[$scope.miCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RENAL": // renalCosts
								$scope.renalCosts.push($scope.renalCosts[$scope.renalCosts.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['ESRD'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalCosts2.push($scope.renalCosts2[$scope.renalCosts2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['ESRD'] * 1 / Math.pow(disc2, parseInt(key) - 1));
								
								$scope.renalCost1.push($scope.renalCost1[$scope.renalCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalCost2.push($scope.renalCost2[$scope.renalCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ESRD": // renalCosts
								$scope.esrdCost1.push($scope.esrdCost1[$scope.esrdCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.esrdCost2.push($scope.esrdCost2[$scope.esrdCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "NEURO": // neuropathyAmpCost
								$scope.neuropathyCost1.push($scope.neuropathyCost1[$scope.neuropathyCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyCost2.push($scope.neuropathyCost2[$scope.neuropathyCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "SVL": // ocularCost
								$scope.retinopathyCost1.push($scope.retinopathyCost1[$scope.retinopathyCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.retinopathyCost2.push($scope.retinopathyCost2[$scope.retinopathyCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								
								$scope.ocularCost.push($scope.ocularCost[$scope.ocularCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['ME'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.ocularCost2.push($scope.ocularCost2[$scope.ocularCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['ME'] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ME": // ocularCost
								$scope.meCost1.push($scope.meCost1[$scope.meCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.meCost2.push($scope.meCost2[$scope.meCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "ULCER": // neuropathyAmpCost
								$scope.ulcerCost1.push($scope.ulcerCost1[$scope.ulcerCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.ulcerCost2.push($scope.ulcerCost2[$scope.ulcerCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RX": // treatmentCost
								$scope.treatmentCost1.push($scope.treatmentCost1[$scope.treatmentCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.treatmentCost2.push($scope.treatmentCost2[$scope.treatmentCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "STROKE": // cvdCost
								$scope.strokeCost1.push($scope.strokeCost1[$scope.strokeCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.strokeCost2.push($scope.strokeCost2[$scope.strokeCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "REVASC": // cvdCost
								$scope.revascCost1.push($scope.revascCost1[$scope.revascCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.revascCost2.push($scope.revascCost2[$scope.revascCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CLBP":
								$scope.clbpCost1.push($scope.clbpCost1[$scope.clbpCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.clbpCost2.push($scope.clbpCost2[$scope.clbpCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "KOA":
								$scope.koaCost1.push($scope.koaCost1[$scope.koaCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.koaCost2.push($scope.koaCost2[$scope.koaCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "POST_TKR":
								$scope.postTkrCost1.push($scope.postTkrCost1[$scope.postTkrCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.postTkrCost2.push($scope.postTkrCost2[$scope.postTkrCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "F0_F2_STEATOSIS":
								$scope.steatosisF0F2Cost1.push($scope.steatosisF0F2Cost1[$scope.steatosisF0F2Cost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.steatosisF0F2Cost2.push($scope.steatosisF0F2Cost2[$scope.steatosisF0F2Cost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "F3_STEATOSIS":
								$scope.steatosisF3Cost1.push($scope.steatosisF3Cost1[$scope.steatosisF3Cost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.steatosisF3Cost2.push($scope.steatosisF3Cost2[$scope.steatosisF3Cost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "F4_COMPENSATED_CIRRHOSIS":
								$scope.compensatedCirrhosisCost1.push($scope.compensatedCirrhosisCost1[$scope.compensatedCirrhosisCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.compensatedCirrhosisCost2.push($scope.compensatedCirrhosisCost2[$scope.compensatedCirrhosisCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "DECOMPENSATED_CIRRHOSIS_HEPATOCELLULAR_CARCINOMA":
								$scope.dccAndHccCost1.push($scope.dccAndHccCost1[$scope.dccAndHccCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.dccAndHccCost2.push($scope.dccAndHccCost2[$scope.dccAndHccCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "LIVER_TRANSPLANT":
								$scope.liverTransplantCost1.push($scope.liverTransplantCost1[$scope.liverTransplantCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.liverTransplantCost2.push($scope.liverTransplantCost2[$scope.liverTransplantCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "POST_LIVER_TRANSPLANT":
								$scope.postLiverTransplantCost1.push($scope.postLiverTransplantCost1[$scope.postLiverTransplantCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.postLiverTransplantCost2.push($scope.postLiverTransplantCost2[$scope.postLiverTransplantCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "INDIRECT":
								$scope.indirectCost1.push($scope.indirectCost1[$scope.indirectCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.indirectCost2.push($scope.indirectCost2[$scope.indirectCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "COMP_FREE":
								$scope.compFreeCost1.push($scope.compFreeCost1[$scope.compFreeCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.compFreeCost2.push($scope.compFreeCost2[$scope.compFreeCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								
								$scope.otherCost.push($scope.otherCost[$scope.otherCost.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].costsOverTime[key].stateProportionMap['UNRELATED_MED'] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.otherCost2.push($scope.otherCost2[$scope.otherCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].costsOverTime[key].stateProportionMap['UNRELATED_MED'] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "UNRELATED_MED":
								$scope.unrelatedMedCost1.push($scope.unrelatedMedCost1[$scope.unrelatedMedCost1.length - 1] + data.arms['0'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.unrelatedMedCost2.push($scope.unrelatedMedCost2[$scope.unrelatedMedCost2.length - 1] + data.arms['1'].costsOverTime[key].stateProportionMap[costCategory] * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
						}
					})
				});
			
				$scope.costSeries = [ "Cardiovascular disease", "Renal", "Treatment", "Hypoglycemia", "Blindness and macular edema", "Neuropathy, amputation, and ulcer", "Indirect", "Routine care" ];

				$scope.costCurve1 = [ $scope.cvdCost2, $scope.renalCosts2, $scope.treatmentCost2, $scope.hypoglycemiaCost2, $scope.ocularCost2, $scope.neuropathyAmpCost2, $scope.indirectCost2, $scope.otherCost2 ];
				$scope.costCurve2 = [ $scope.cvdCost, $scope.renalCosts, $scope.treatmentCost1, $scope.hypoglycemiaCost1, $scope.ocularCost, $scope.neuropathyAmpCost, $scope.indirectCost1, $scope.otherCost ];

				if ($scope.hasObesity) {
					$scope.costSeries.push("Chronic lower back pain");
					$scope.costCurve1.push($scope.clbpCost2);
					$scope.costCurve2.push($scope.clbpCost1);
					$scope.costSeries.push("Knee osteoarthritis");
					$scope.costCurve1.push($scope.koaCost2);
					$scope.costCurve2.push($scope.koaCost1);
					$scope.costSeries.push("Post-total knee replacement");
					$scope.costCurve1.push($scope.postTkrCost2);
					$scope.costCurve2.push($scope.postTkrCost1);
					$scope.costSeries.push("Steatosis F0-F2");
					$scope.costCurve1.push($scope.steatosisF0F2Cost2);
					$scope.costCurve2.push($scope.steatosisF0F2Cost1);
					$scope.costSeries.push("Steatosis F3");
					$scope.costCurve1.push($scope.steatosisF3Cost2);
					$scope.costCurve2.push($scope.steatosisF3Cost1);
					$scope.costSeries.push("Compensated cirrhosis");
					$scope.costCurve1.push($scope.compensatedCirrhosisCost2);
					$scope.costCurve2.push($scope.compensatedCirrhosisCost1);
					$scope.costSeries.push("Decompensated cirrhosis and hepatocellular carcinoma");
					$scope.costCurve1.push($scope.dccAndHccCost2);
					$scope.costCurve2.push($scope.dccAndHccCost1);
					$scope.costSeries.push("Liver transplant");
					$scope.costCurve1.push($scope.liverTransplantCost2);
					$scope.costCurve2.push($scope.liverTransplantCost1);
					$scope.costSeries.push("Post-liver transplant");
					$scope.costCurve1.push($scope.postLiverTransplantCost2);
					$scope.costCurve2.push($scope.postLiverTransplantCost1);
				}
			}
		})();
		
		

		$scope.discountedQoLBreakdown = true;
		($scope.recalcQoLBreakdown = function() {
			if (data.arms['0'].qolOverTime !== undefined) {
			
				$scope.cvdQoL = [0],
				$scope.renalQoLs = [0],
				$scope.treatmentsQoL = [0],
				$scope.adverseEventQoL = [0],
				$scope.ocularQoL = [0],
				$scope.neuropathyAmpQoL = [0],
				$scope.cvdQoL2 = [0],
				$scope.renalQoLs2 = [0],
				$scope.treatmentsQoL2 = [0],
				$scope.adverseEventQoL2 = [0],
				$scope.ocularQoL2 = [0],
				$scope.neuropathyAmpQoL2 = [0];
		
				$scope.miQoL1 = [0],
				$scope.strokeQoL1 = [0],
				$scope.anginaQoL1 = [0],
				$scope.chfQoL1 = [0],
				$scope.retinopathyQoL1 = [0],
				$scope.meQoL1 = [0],
				$scope.neuropathyQoL1 = [0],
				$scope.amputationQoL1 = [0],
				$scope.renalQoL1 = [0],
				$scope.hypoglycemiaQoL1 = [0],
				$scope.treatmentQoL1 = [0],
				$scope.miQoL2 = [0],
				$scope.strokeQoL2 = [0],
				$scope.anginaQoL2 = [0],
				$scope.chfQoL2 = [0],
				$scope.retinopathyQoL2 = [0],
				$scope.meQoL2 = [0],
				$scope.neuropathyQoL2 = [0],
				$scope.amputationQoL2 = [0],
				$scope.renalQoL2 = [0],
				$scope.hypoglycemiaQoL2 = [0],
				$scope.treatmentQoL2 = [0],
				$scope.clbpQoL1 = [0],
				$scope.clbpQoL2 = [0],
				$scope.koaQol1 = [0],
				$scope.koaQol2 = [0],
				$scope.postTkrQol1 = [0],
				$scope.postTkrQol2 = [0],
				$scope.steatosisF0F2Qol1 = [0],
				$scope.steatosisF0F2Qol2 = [0],
				$scope.steatosisF3Qol1 = [0],
				$scope.steatosisF3Qol2 = [0],
				$scope.compensatedCirrhosisQol1 = [0],
				$scope.compensatedCirrhosisQol2 = [0],
				$scope.dccAndHccQol1 = [0],
				$scope.dccAndHccQol2 = [0],
				$scope.liverTransplantQol1 = [0],
				$scope.liverTransplantQol2 = [0],
				$scope.postLiverTransplantQol1 = [0],
				$scope.postLiverTransplantQol2 = [0]
				;
			
				var disc1 = $scope.discountedQoLBreakdown ? (1 + data.fullElements.countries[0].effectDiscountRate / 100) : 1,
					disc2 = $scope.discountedQoLBreakdown ? (data.fullElements.countries.length > 1 ? (1 + data.fullElements.countries[1].effectDiscountRate / 100) : (1 + data.fullElements.countries[0].effectDiscountRate / 100)) : 1;
				
				Object.keys(data.arms['0'].qolOverTime).forEach(function(key) {
					Object.keys(data.arms['0'].qolOverTime[key].stateProportionMap).forEach(function(qolCategory) {
						switch (qolCategory) {
							case "AMP":
								$scope.neuropathyAmpQoL.push($scope.neuropathyAmpQoL[$scope.neuropathyAmpQoL.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['NEURO'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['ULCER'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyAmpQoL2.push($scope.neuropathyAmpQoL2[$scope.neuropathyAmpQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['NEURO'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['ULCER'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
							
								$scope.amputationQoL1.push($scope.amputationQoL1[$scope.amputationQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.amputationQoL2.push($scope.amputationQoL2[$scope.amputationQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "IHD":
								$scope.cvdQoL.push($scope.cvdQoL[$scope.cvdQoL.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['CHF'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['MI'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['STROKE'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.cvdQoL2.push($scope.cvdQoL2[$scope.cvdQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['CHF'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['MI'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['STROKE'] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1))
							
								$scope.anginaQoL1.push($scope.anginaQoL1[$scope.anginaQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.anginaQoL2.push($scope.anginaQoL2[$scope.anginaQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CHF":
								$scope.chfQoL1.push($scope.chfQoL1[$scope.chfQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.chfQoL2.push($scope.chfQoL2[$scope.chfQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "HYPO":
								$scope.hypoglycemiaQoL1.push($scope.hypoglycemiaQoL1[$scope.hypoglycemiaQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.hypoglycemiaQoL2.push($scope.hypoglycemiaQoL2[$scope.hypoglycemiaQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "MI":
								$scope.miQoL1.push($scope.miQoL1[$scope.miQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.miQoL2.push($scope.miQoL2[$scope.miQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RENAL":
								$scope.renalQoLs.push($scope.renalQoLs[$scope.renalQoLs.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalQoLs2.push($scope.renalQoLs2[$scope.renalQoLs2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								$scope.renalQoL1.push($scope.renalQoL1[$scope.renalQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.renalQoL2.push($scope.renalQoL2[$scope.renalQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "NEURO":
								$scope.neuropathyQoL1.push($scope.neuropathyQoL1[$scope.neuropathyQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.neuropathyQoL2.push($scope.neuropathyQoL2[$scope.neuropathyQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "SVL":
								$scope.retinopathyQoL1.push($scope.retinopathyQoL1[$scope.retinopathyQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.retinopathyQoL2.push($scope.retinopathyQoL2[$scope.retinopathyQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								
								$scope.ocularQoL.push($scope.ocularQoL[$scope.ocularQoL.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1) + data.arms['0'].qolOverTime[key].stateProportionMap['ME'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.ocularQoL2.push($scope.ocularQoL2[$scope.ocularQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1) + data.arms['1'].qolOverTime[key].stateProportionMap['ME'] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								break;
							case "ME":
								$scope.meQoL1.push($scope.meQoL1[$scope.meQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.meQoL2.push($scope.meQoL2[$scope.meQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "RX":					
								$scope.treatmentQoL1.push($scope.treatmentQoL1[$scope.treatmentQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.treatmentQoL2.push($scope.treatmentQoL2[$scope.treatmentQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "STROKE":
								$scope.strokeQoL1.push($scope.strokeQoL1[$scope.strokeQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.strokeQoL2.push($scope.strokeQoL2[$scope.strokeQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "CLBP":
								$scope.clbpQoL1.push($scope.clbpQoL1[$scope.clbpQoL1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.clbpQoL2.push($scope.clbpQoL2[$scope.clbpQoL2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "KOA":
								$scope.koaQol1.push($scope.koaQol1[$scope.koaQol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.koaQol2.push($scope.koaQol2[$scope.koaQol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "POST_TKR":
								$scope.postTkrQol1.push($scope.postTkrQol1[$scope.postTkrQol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.postTkrQol2.push($scope.postTkrQol2[$scope.postTkrQol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "F0_F2_STEATOSIS":
								$scope.steatosisF0F2Qol1.push($scope.steatosisF0F2Qol1[$scope.steatosisF0F2Qol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.steatosisF0F2Qol2.push($scope.steatosisF0F2Qol2[$scope.steatosisF0F2Qol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "F3_STEATOSIS":
								$scope.steatosisF3Qol1.push($scope.steatosisF3Qol1[$scope.steatosisF3Qol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.steatosisF3Qol2.push($scope.steatosisF3Qol2[$scope.steatosisF3Qol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "F4_COMPENSATED_CIRRHOSIS":
								$scope.compensatedCirrhosisQol1.push($scope.compensatedCirrhosisQol1[$scope.compensatedCirrhosisQol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.compensatedCirrhosisQol2.push($scope.compensatedCirrhosisQol2[$scope.compensatedCirrhosisQol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "DECOMPENSATED_CIRRHOSIS_HEPATOCELLULAR_CARCINOMA":
								$scope.dccAndHccQol1.push($scope.dccAndHccQol1[$scope.dccAndHccQol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.dccAndHccQol2.push($scope.dccAndHccQol2[$scope.dccAndHccQol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "LIVER_TRANSPLANT":
								$scope.liverTransplantQol1.push($scope.liverTransplantQol1[$scope.liverTransplantQol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.liverTransplantQol2.push($scope.liverTransplantQol2[$scope.liverTransplantQol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
							case "POST_LIVER_TRANSPLANT":
								$scope.postLiverTransplantQol1.push($scope.postLiverTransplantQol1[$scope.postLiverTransplantQol1.length - 1] + data.arms['0'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc1, parseInt(key) - 1));
								$scope.postLiverTransplantQol2.push($scope.postLiverTransplantQol2[$scope.postLiverTransplantQol2.length - 1] + data.arms['1'].qolOverTime[key].stateProportionMap[qolCategory] / data.patients * 1 / Math.pow(disc2, parseInt(key) - 1));
								break;
						}
					})
				});

				$scope.qolSeries = [ "Cardiovascular disease", "Renal", "Treatment", "Hypoglycemia", "Blindness and macular edema", "Neuropathy, amputation, and ulcer" ];

				$scope.qolCurve1 = [ $scope.cvdQoL2, $scope.renalQoL2, $scope.treatmentQoL2, $scope.hypoglycemiaQoL2, $scope.ocularQoL2, $scope.neuropathyAmpQoL2 ];
				$scope.qolCurve2 = [ $scope.cvdQoL, $scope.renalQoL1, $scope.treatmentQoL1, $scope.hypoglycemiaQoL1, $scope.ocularQoL, $scope.neuropathyAmpQoL ];

				if ($scope.hasObesity) {
					$scope.qolSeries.push("Chronic lower back pain");
					$scope.qolCurve1.push($scope.clbpQoL2);
					$scope.qolCurve2.push($scope.clbpQoL1);
					$scope.qolSeries.push("Knee osteoarthritis");
					$scope.qolCurve1.push($scope.koaQol2);
					$scope.qolCurve2.push($scope.koaQol1);
					$scope.qolSeries.push("Post-total knee replacement");
					$scope.qolCurve1.push($scope.postTkrQol2);
					$scope.qolCurve2.push($scope.postTkrQol1);
					$scope.qolSeries.push("Steatosis F0-F2");
					$scope.qolCurve1.push($scope.steatosisF0F2Qol2);
					$scope.qolCurve2.push($scope.steatosisF0F2Qol1);
					$scope.qolSeries.push("Steatosis F3");
					$scope.qolCurve1.push($scope.steatosisF3Qol2);
					$scope.qolCurve2.push($scope.steatosisF3Qol1);
					$scope.qolSeries.push("Compensated cirrhosis");
					$scope.qolCurve1.push($scope.compensatedCirrhosisQol2);
					$scope.qolCurve2.push($scope.compensatedCirrhosisQol1);
					$scope.qolSeries.push("Decompensated cirrhosis and hepatocellular carcinoma");
					$scope.qolCurve1.push($scope.dccAndHccQol2);
					$scope.qolCurve2.push($scope.dccAndHccQol1);
					$scope.qolSeries.push("Liver transplant");
					$scope.qolCurve1.push($scope.liverTransplantQol2);
					$scope.qolCurve2.push($scope.liverTransplantQol1);
					$scope.qolSeries.push("Post-liver transplant");
					$scope.qolCurve1.push($scope.postLiverTransplantQol2);
					$scope.qolCurve2.push($scope.postLiverTransplantQol1);
				}
			}
		})();




		$scope.complicationColors = [ '#4D5360', '#888888', '#803690', '#00ADF9', '#52996b', '#46BFBD', '#FDB45C', '#949FB1', '#E2EAE9', '#F7464A', '#46BFBD', '#46BFBD', "#00ADF9", "#46BFBD", "#46BFBD", "#00ADF9", "#46BFBD", "#46BFBD", "#46BFBD", "#00ADF9", "#46BFBD" ];
		$scope.complicationCumulativeIncidenceLabels = ["Myocardial infarction", "Stroke", "Ischemic heart disease", "Revascularization", "Congestive heart failure", "Ulcer", "Amputation", "Blindness", "Macular edema", "Neuropathy", "Renal failure"];
		if ($scope.hasObesity) {
			$scope.complicationCumulativeIncidenceLabels.push("Chronic lower back pain");
			$scope.complicationCumulativeIncidenceLabels.push("Knee osteoarthritis");
			$scope.complicationCumulativeIncidenceLabels.push("Post-total knee replacement");
			$scope.complicationCumulativeIncidenceLabels.push("Metabolic dysfunction-associated steatotic liver disease");
		}
		
		$scope.complicationCumulativeIncidenceOptions = angular.copy($scope.options);
		$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].scaleLabel.labelString = "Cumulative incidence";
		$scope.complicationCumulativeIncidenceOptions.aspectRatio = 1.25;
		$scope.complicationCumulativeIncidenceOptions.tooltips.callbacks.label =  function(tooltipItem, data) {
					if (typeof tooltipItem.yLabel === "string") {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toFixed(3);
					} else {
						return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toFixed(3);	
					}
				};
		
	
		$scope.animateComplicationIncidence = function() {
			if ($scope.animating) {
				$scope.animating = !$scope.animating;
				$interval.cancel($scope.cumulativeIncidenceAnimation);
				
				var arm1Incidence = [
					data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime ? data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceFirstStrokeOverTime ? data.arms['1'].cumulativeIncidenceFirstStrokeOverTime[data.arms['1'].cumulativeIncidenceFirstStrokeOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime ? data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceRevascularizationOverTime !== undefined && data.arms['1'].cumulativeIncidenceRevascularizationOverTime ? data.arms['1'].cumulativeIncidenceRevascularizationOverTime[data.arms['1'].cumulativeIncidenceRevascularizationOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceHeartFailureOverTime ? data.arms['1'].cumulativeIncidenceHeartFailureOverTime[data.arms['1'].cumulativeIncidenceHeartFailureOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceUlcerOverTime ? data.arms['1'].cumulativeIncidenceUlcerOverTime[data.arms['1'].cumulativeIncidenceUlcerOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceFirstAmputationOverTime ? data.arms['1'].cumulativeIncidenceFirstAmputationOverTime[data.arms['1'].cumulativeIncidenceFirstAmputationOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceBlindnessOverTime ? data.arms['1'].cumulativeIncidenceBlindnessOverTime[data.arms['1'].cumulativeIncidenceBlindnessOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceMacularEdemaOverTime !== undefined && data.arms['1'].cumulativeIncidenceMacularEdemaOverTime ? data.arms['1'].cumulativeIncidenceMacularEdemaOverTime[data.arms['1'].cumulativeIncidenceMacularEdemaOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceNeuropathyOverTime ? data.arms['1'].cumulativeIncidenceNeuropathyOverTime[data.arms['1'].cumulativeIncidenceNeuropathyOverTime.length - 1] : 0,
					data.arms['1'].cumulativeIncidenceRenalFailureOverTime ? data.arms['1'].cumulativeIncidenceRenalFailureOverTime[data.arms['1'].cumulativeIncidenceRenalFailureOverTime.length - 1] : 0
				];
				var arm0Incidence = [
					data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime ? data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceFirstStrokeOverTime ? data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[data.arms['0'].cumulativeIncidenceFirstStrokeOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime ? data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceRevascularizationOverTime !== undefined && data.arms['0'].cumulativeIncidenceRevascularizationOverTime ? data.arms['0'].cumulativeIncidenceRevascularizationOverTime[data.arms['0'].cumulativeIncidenceRevascularizationOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceHeartFailureOverTime ? data.arms['0'].cumulativeIncidenceHeartFailureOverTime[data.arms['0'].cumulativeIncidenceHeartFailureOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceUlcerOverTime ? data.arms['0'].cumulativeIncidenceUlcerOverTime[data.arms['0'].cumulativeIncidenceUlcerOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceFirstAmputationOverTime ? data.arms['0'].cumulativeIncidenceFirstAmputationOverTime[data.arms['0'].cumulativeIncidenceFirstAmputationOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceBlindnessOverTime ? data.arms['0'].cumulativeIncidenceBlindnessOverTime[data.arms['0'].cumulativeIncidenceBlindnessOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceMacularEdemaOverTime !== undefined && data.arms['0'].cumulativeIncidenceMacularEdemaOverTime ? data.arms['0'].cumulativeIncidenceMacularEdemaOverTime[data.arms['0'].cumulativeIncidenceMacularEdemaOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceNeuropathyOverTime ? data.arms['0'].cumulativeIncidenceNeuropathyOverTime[data.arms['0'].cumulativeIncidenceNeuropathyOverTime.length - 1] : 0,
					data.arms['0'].cumulativeIncidenceRenalFailureOverTime ? data.arms['0'].cumulativeIncidenceRenalFailureOverTime[data.arms['0'].cumulativeIncidenceRenalFailureOverTime.length - 1] : 0
				];
				if ($scope.hasObesity) {
					arm1Incidence.push(data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime ? data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime[data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime.length - 1] : 0);
					arm0Incidence.push(data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime ? data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime[data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime.length - 1] : 0);
					arm1Incidence.push(data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime ? data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime[data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime.length - 1] : 0);
					arm0Incidence.push(data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime ? data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime[data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime.length - 1] : 0);
					arm1Incidence.push(data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime ? data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime[data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime.length - 1] : 0);
					arm0Incidence.push(data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime ? data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime[data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime.length - 1] : 0);
					arm1Incidence.push(data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime ? data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime[data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime.length - 1] : 0);
					arm0Incidence.push(data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime ? data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime[data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime.length - 1] : 0);
				}
				$scope.complicationCumulativeIncidence = [arm1Incidence, arm0Incidence];
			} else {
				$scope.animating = !$scope.animating;
				$scope.animationProgress = 0;
				$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].ticks.min = 0;
				$scope.complicationCumulativeIncidenceOptions.scales.xAxes[0].ticks.max = 1;
				var resetArm1 = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];
				var resetArm0 = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];
				if ($scope.hasObesity) {
					resetArm1.push(0.0, 0.0, 0.0, 0.0);
					resetArm0.push(0.0, 0.0, 0.0, 0.0);
				}
				$scope.complicationCumulativeIncidence = [resetArm1, resetArm0];
			
				$scope.cumulativeIncidenceAnimation = $interval(function() { 
					var tickArm1 = [
						data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime ? data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceFirstStrokeOverTime ? data.arms['1'].cumulativeIncidenceFirstStrokeOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime ? data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceRevascularizationOverTime !== undefined && data.arms['1'].cumulativeIncidenceRevascularizationOverTime ? data.arms['1'].cumulativeIncidenceRevascularizationOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceHeartFailureOverTime ? data.arms['1'].cumulativeIncidenceHeartFailureOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceUlcerOverTime ? data.arms['1'].cumulativeIncidenceUlcerOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceFirstAmputationOverTime ? data.arms['1'].cumulativeIncidenceFirstAmputationOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceBlindnessOverTime ? data.arms['1'].cumulativeIncidenceBlindnessOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceMacularEdemaOverTime !== undefined && data.arms['1'].cumulativeIncidenceMacularEdemaOverTime ? data.arms['1'].cumulativeIncidenceMacularEdemaOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceNeuropathyOverTime ? data.arms['1'].cumulativeIncidenceNeuropathyOverTime[$scope.animationProgress] : 0,
						data.arms['1'].cumulativeIncidenceRenalFailureOverTime ? data.arms['1'].cumulativeIncidenceRenalFailureOverTime[$scope.animationProgress] : 0
					];
					var tickArm0 = [
						data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime ? data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceFirstStrokeOverTime ? data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime ? data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceRevascularizationOverTime !== undefined && data.arms['0'].cumulativeIncidenceRevascularizationOverTime ? data.arms['0'].cumulativeIncidenceRevascularizationOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceHeartFailureOverTime ? data.arms['0'].cumulativeIncidenceHeartFailureOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceUlcerOverTime ? data.arms['0'].cumulativeIncidenceUlcerOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceFirstAmputationOverTime ? data.arms['0'].cumulativeIncidenceFirstAmputationOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceBlindnessOverTime ? data.arms['0'].cumulativeIncidenceBlindnessOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceMacularEdemaOverTime !== undefined && data.arms['0'].cumulativeIncidenceMacularEdemaOverTime ? data.arms['0'].cumulativeIncidenceMacularEdemaOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceNeuropathyOverTime ? data.arms['0'].cumulativeIncidenceNeuropathyOverTime[$scope.animationProgress] : 0,
						data.arms['0'].cumulativeIncidenceRenalFailureOverTime ? data.arms['0'].cumulativeIncidenceRenalFailureOverTime[$scope.animationProgress] : 0
					];
					if ($scope.hasObesity) {
						tickArm1.push(data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime ? data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime[$scope.animationProgress] : 0);
						tickArm0.push(data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime ? data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime[$scope.animationProgress] : 0);
						tickArm1.push(data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime ? data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime[$scope.animationProgress] : 0);
						tickArm0.push(data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime ? data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime[$scope.animationProgress] : 0);
						tickArm1.push(data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime ? data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime[$scope.animationProgress] : 0);
						tickArm0.push(data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime ? data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime[$scope.animationProgress] : 0);
						tickArm1.push(data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime ? data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime[$scope.animationProgress] : 0);
						tickArm0.push(data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime ? data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime[$scope.animationProgress] : 0);
					}
					$scope.complicationCumulativeIncidence = [tickArm1, tickArm0];
					if ($scope.animationProgress >= data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1) {
						$scope.animationProgress = 0;
					} else {
						$scope.animationProgress++;
					}
				}, 200);	
			}
		}
		
		var initArm1 = [
			data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime ? data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceFirstStrokeOverTime ? data.arms['1'].cumulativeIncidenceFirstStrokeOverTime[data.arms['1'].cumulativeIncidenceFirstStrokeOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime ? data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceRevascularizationOverTime !== undefined && data.arms['1'].cumulativeIncidenceRevascularizationOverTime ? data.arms['1'].cumulativeIncidenceRevascularizationOverTime[data.arms['1'].cumulativeIncidenceRevascularizationOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceHeartFailureOverTime ? data.arms['1'].cumulativeIncidenceHeartFailureOverTime[data.arms['1'].cumulativeIncidenceHeartFailureOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceUlcerOverTime ? data.arms['1'].cumulativeIncidenceUlcerOverTime[data.arms['1'].cumulativeIncidenceUlcerOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceFirstAmputationOverTime ? data.arms['1'].cumulativeIncidenceFirstAmputationOverTime[data.arms['1'].cumulativeIncidenceFirstAmputationOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceBlindnessOverTime ? data.arms['1'].cumulativeIncidenceBlindnessOverTime[data.arms['1'].cumulativeIncidenceBlindnessOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceMacularEdemaOverTime !== undefined && data.arms['1'].cumulativeIncidenceMacularEdemaOverTime ? data.arms['1'].cumulativeIncidenceMacularEdemaOverTime[data.arms['1'].cumulativeIncidenceMacularEdemaOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceNeuropathyOverTime ? data.arms['1'].cumulativeIncidenceNeuropathyOverTime[data.arms['1'].cumulativeIncidenceNeuropathyOverTime.length - 1] : 0,
			data.arms['1'].cumulativeIncidenceRenalFailureOverTime ? data.arms['1'].cumulativeIncidenceRenalFailureOverTime[data.arms['1'].cumulativeIncidenceRenalFailureOverTime.length - 1] : 0
		];
		var initArm0 = [
			data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime ? data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime[data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceFirstStrokeOverTime ? data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[data.arms['0'].cumulativeIncidenceFirstStrokeOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime ? data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceRevascularizationOverTime !== undefined && data.arms['0'].cumulativeIncidenceRevascularizationOverTime ? data.arms['0'].cumulativeIncidenceRevascularizationOverTime[data.arms['0'].cumulativeIncidenceRevascularizationOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceHeartFailureOverTime ? data.arms['0'].cumulativeIncidenceHeartFailureOverTime[data.arms['0'].cumulativeIncidenceHeartFailureOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceUlcerOverTime ? data.arms['0'].cumulativeIncidenceUlcerOverTime[data.arms['0'].cumulativeIncidenceUlcerOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceFirstAmputationOverTime ? data.arms['0'].cumulativeIncidenceFirstAmputationOverTime[data.arms['0'].cumulativeIncidenceFirstAmputationOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceBlindnessOverTime ? data.arms['0'].cumulativeIncidenceBlindnessOverTime[data.arms['0'].cumulativeIncidenceBlindnessOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceMacularEdemaOverTime !== undefined && data.arms['0'].cumulativeIncidenceMacularEdemaOverTime ? data.arms['0'].cumulativeIncidenceMacularEdemaOverTime[data.arms['0'].cumulativeIncidenceMacularEdemaOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceNeuropathyOverTime ? data.arms['0'].cumulativeIncidenceNeuropathyOverTime[data.arms['0'].cumulativeIncidenceNeuropathyOverTime.length - 1] : 0,
			data.arms['0'].cumulativeIncidenceRenalFailureOverTime ? data.arms['0'].cumulativeIncidenceRenalFailureOverTime[data.arms['0'].cumulativeIncidenceRenalFailureOverTime.length - 1] : 0
		];
		if ($scope.hasObesity) {
			initArm1.push(data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime ? data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime[data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime.length - 1] : 0);
			initArm0.push(data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime ? data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime[data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime.length - 1] : 0);
			initArm1.push(data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime ? data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime[data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime.length - 1] : 0);
			initArm0.push(data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime ? data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime[data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime.length - 1] : 0);
			initArm1.push(data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime ? data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime[data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime.length - 1] : 0);
			initArm0.push(data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime ? data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime[data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime.length - 1] : 0);
			initArm1.push(data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime ? data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime[data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime.length - 1] : 0);
			initArm0.push(data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime ? data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime[data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime.length - 1] : 0);
		}
		$scope.complicationCumulativeIncidence = [initArm1, initArm0];
		
		
		
		$scope.treatmentLinesLabels1 = [];
		$scope.treatmentLineSeries1 = [];
		$scope.treatmentLineData1 = [];
		$scope.treatmentLineOverride1 = [];
		
		if (data.arms['0'].treatmentProgression != undefined) {
			Object.keys(data.arms['0'].treatmentProgression).forEach(function(o) {
				$scope.treatmentLinesLabels1.push(o);
			});
		
			const treatmentLines = new Set();
			Object.values(data.arms['0'].treatmentProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					treatmentLines.add(k);
				})
			});
		
			$scope.treatmentLineSeries1 = Array.from(treatmentLines.values());
		
			var treatmentLineData = [];
			var treatmentLineOverride = [];
		
			$scope.treatmentLineSeries1.forEach(function(line, i) {
				var lineOverTime = new Array();
				Object.entries(data.arms['0'].treatmentProgression).forEach(function(treatmentBreakdownInYear) {
					if (treatmentBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(treatmentBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				treatmentLineData.push(lineOverTime);
				treatmentLineOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});	
			
			$scope.treatmentLineData1 = treatmentLineData;
			$scope.treatmentLineOverride1 = treatmentLineOverride;
		}
		
		
		$scope.treatmentLinesLabels2 = [];
		$scope.treatmentLineSeries2 = [];
		$scope.treatmentLineData2 = [];
		$scope.treatmentLineOverride2 = [];
		
		if (data.arms['1'].treatmentProgression != undefined) {
			Object.keys(data.arms['1'].treatmentProgression).forEach(function(o) {
				$scope.treatmentLinesLabels2.push(o);
			});
		
			const treatmentLines2 = new Set();
			Object.values(data.arms['1'].treatmentProgression).forEach(function(o) {
				Object.keys(o).forEach(function(k) {
					treatmentLines2.add(k);
				})
			});
		
			$scope.treatmentLineSeries2 = Array.from(treatmentLines2.values());
		
			treatmentLineData = [];
			treatmentLineOverride = [];
		
			$scope.treatmentLineSeries2.forEach(function(line, i) {
				var lineOverTime = new Array();
				Object.entries(data.arms['1'].treatmentProgression).forEach(function(treatmentBreakdownInYear) {
					if (treatmentBreakdownInYear[1].hasOwnProperty(line)) {
						lineOverTime.push(treatmentBreakdownInYear[1][line] * 100);
					} else {
						lineOverTime.push(0);
					}
				})
				treatmentLineData.push(lineOverTime);
				treatmentLineOverride.push({
					borderWidth: 0,
					backgroundColor: $scope.complicationColors[i]
				});
			});
		
			$scope.treatmentLineData2 = treatmentLineData;
			$scope.treatmentLineOverride2 = treatmentLineOverride;
		}
		
		$scope.cvdSeries = ["Myocardial infarction", "Stroke", "Ischemic heart disease"];
		
		($scope.rescaleCVD = function() {
			$scope.cvdStackedOptions.elements.line.fill = $scope.cvdStackedOptions.scales.yAxes['0'].stacked;
			
			var allValues = [];
			if ($scope.cvdStackedOptions.scales.yAxes[0].stacked) {
				data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime.forEach(function(val, i, arr) {
					allValues.push(val + data.arms['0'].cumulativeIncidenceFirstStrokeOverTime[i] + data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime[i]);
				});	
			} else {
				allValues = data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime
					.concat(data.arms['0'].cumulativeIncidenceFirstStrokeOverTime)
					.concat(data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime)
					.concat(data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime)
					.concat(data.arms['1'].cumulativeIncidenceFirstStrokeOverTime)
					.concat(data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime);
			}
		
			$scope.cvdStackedOptions.scales.yAxes[0].ticks.suggestedMax = allValues.reduce(function(a, b) {
				return Math.max(a, b);
			}) * 1.05;	
		})();

    $scope.cvdCurve1 = [data.arms['1'].cumulativeIncidenceFirstMyocardialInfarctOverTime, data.arms['1'].cumulativeIncidenceFirstStrokeOverTime, data.arms['1'].cumulativeIncidenceIschemicHeartDiseaseOverTime];
    $scope.cvdCurve2 = [data.arms['0'].cumulativeIncidenceFirstMyocardialInfarctOverTime, data.arms['0'].cumulativeIncidenceFirstStrokeOverTime, data.arms['0'].cumulativeIncidenceIschemicHeartDiseaseOverTime];

		$scope.nephropathySeries = ["Renal failure"];
		$scope.nephropathyCurve1 = [data.arms['0'].cumulativeIncidenceRenalFailureOverTime];
		$scope.nephropathyCurve2 = [data.arms['1'].cumulativeIncidenceRenalFailureOverTime];

		$scope.maceCurves = [data.arms['1'].cumulativeIncidenceMACEOverTime, data.arms['0'].cumulativeIncidenceMACEOverTime];

		if ($scope.hasObesity) {
			$scope.clbpCurves = [data.arms['1'].cumulativeIncidenceChronicLowerBackPainOverTime, data.arms['0'].cumulativeIncidenceChronicLowerBackPainOverTime];

			$scope.koaSeries = ["Knee osteoarthritis intervention", "Knee osteoarthritis comparator", "Post-total knee replacement intervention", "Post-total knee replacement comparator"];
			$scope.koaCurves = [
				data.arms['1'].cumulativeIncidenceKneeOsteoarthritisOverTime,
				data.arms['0'].cumulativeIncidenceKneeOsteoarthritisOverTime,
				data.arms['1'].cumulativeIncidenceTotalKneeReplacementOverTime,
				data.arms['0'].cumulativeIncidenceTotalKneeReplacementOverTime
			];

			$scope.masldCurves = [data.arms['1'].cumulativeIncidenceSteatoticLiverDiseaseOverTime, data.arms['0'].cumulativeIncidenceSteatoticLiverDiseaseOverTime];
		}
		
		$scope.revascSeries = ["Revascularization"];
		$scope.revascCurve1 = [data.arms['0'].cumulativeIncidenceRevascularizationOverTime];
		$scope.revascCurve2 = [data.arms['1'].cumulativeIncidenceRevascularizationOverTime];
		
		$scope.neuropathySeries = ["Amputation", "Ulcer", "Neuropathy"]
		$scope.neuropathyCurve1 = [
			data.arms['0'].cumulativeIncidenceFirstAmputationOverTime, 
			data.arms['0'].cumulativeIncidenceUlcerOverTime, 
			data.arms['0'].cumulativeIncidenceNeuropathyOverTime
		];
		$scope.neuropathyCurve2 = [
			data.arms['1'].cumulativeIncidenceFirstAmputationOverTime,
			data.arms['1'].cumulativeIncidenceUlcerOverTime, 
			data.arms['1'].cumulativeIncidenceNeuropathyOverTime
		];
		
		$scope.blindnessSeries = ["Blindness", "Macular edema"];
		$scope.blindnessCurve1 = [data.arms['0'].cumulativeIncidenceBlindnessOverTime, data.arms['0'].cumulativeIncidenceMacularEdemaOverTime];
		$scope.blindnessCurve2 = [data.arms['1'].cumulativeIncidenceBlindnessOverTime, data.arms['1'].cumulativeIncidenceMacularEdemaOverTime];
		
		
		if (data.psa) {
			$scope.scatterOptions = {
				type: 'scatter',
				animation: false,
				tooltips: {
					callbacks: {
						title: function(tooltipItem, tooltipData) {
							return '';
						},
						label: function(tooltipItem, tooltipData) {
							return (tooltipItem.xLabel.toFixed(3) > 0 ? "+" : "") + tooltipItem.xLabel.toFixed(3) + " QALYs   " + 
							tooltipItem.yLabel.toFixed(2) + " " + data.fullElements.costs[0].currency;	
						}
					}
				},
				showLines : false,
				scales: {
					yAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Incremental cost' + (data.fullElements.costs[0].currency !== undefined ? " (" + data.fullElements.costs[0].currency + ")" : "")
						}
					}],
					xAxes: [{
						type: 'linear',
						position: 'bottom',
						scaleLabel: {
							display: true,
							labelString: 'Incremental quality-adjusted life expectancy (QALYs)'
						}
						/*ticks: {
							max:0
						}*/
					}]
				}
			}
			$scope.psa = [];
			$scope.psaDiffs = {};
			$scope.psaDiffs.qale = [];
			$scope.psaDiffs.le = [];
			$scope.psaDiffs.cost = [];
			
			$scope.psaConfidenceIntervals = {};
			$scope.psaConfidenceIntervals.icerSum = 0;
			$scope.psaConfidenceIntervals.arm0 = {};
			$scope.psaConfidenceIntervals.arm0.qale95CILB = 0;
			$scope.psaConfidenceIntervals.arm0.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.arm0.cost95CILB = 0;
			$scope.psaConfidenceIntervals.arm0.cost95CIUB = 0;
			
			$scope.psaConfidenceIntervals.arm1 = {};
			$scope.psaConfidenceIntervals.arm1.qale95CILB = 0;
			$scope.psaConfidenceIntervals.arm1.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.arm1.cost95CILB = 0;
			$scope.psaConfidenceIntervals.arm1.cost95CIUB = 0;
			
			$scope.psaConfidenceIntervals.diff = {};
			$scope.psaConfidenceIntervals.diff.qale95CILB = 0;
			$scope.psaConfidenceIntervals.diff.qale95CIUB = 0;
			$scope.psaConfidenceIntervals.diff.cost95CILB = 0;
			$scope.psaConfidenceIntervals.diff.cost95CIUB = 0;
			
			for (var i = 0; i < data.arms['0'].psaResults.length; i++) {
				$scope.psa.push({
					x: (data.arms['1'].psaResults[i].qale - data.arms['0'].psaResults[i].qale),
					y: (data.arms['1'].psaResults[i].cost - data.arms['0'].psaResults[i].cost)
				});
				$scope.psaDiffs.qale.push(data.arms['1'].psaResults[i].qale - data.arms['0'].psaResults[i].qale);
				$scope.psaDiffs.le.push(data.arms['1'].psaResults[i].le - data.arms['0'].psaResults[i].le);
				$scope.psaDiffs.cost.push(data.arms['1'].psaResults[i].cost - data.arms['0'].psaResults[i].cost);
			}
			
			$scope.psaConfidenceIntervals.arm0.qale95CILB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.qale; })) - Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.qale; }));
			$scope.psaConfidenceIntervals.arm0.qale95CIUB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.qale; })) + Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.qale; }));
			
			$scope.psaConfidenceIntervals.arm0.le95CILB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.le; })) - Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.le; }));
			$scope.psaConfidenceIntervals.arm0.le95CIUB = Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.le; })) + Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.le; }));
			
			$scope.psaConfidenceIntervals.arm0.cost95CILB = (Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.cost; })) - Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.cost; })));
			$scope.psaConfidenceIntervals.arm0.cost95CIUB = (Stats.mean(data.arms['0'].psaResults.map(function(i) { return i.cost; })) + Stats.sd(data.arms['0'].psaResults.map(function(i) { return i.cost; })));
			
			
			
			$scope.psaConfidenceIntervals.arm1.qale95CILB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.qale; })) - Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.qale; }));
			$scope.psaConfidenceIntervals.arm1.qale95CIUB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.qale; })) + Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.qale; }));
			
			$scope.psaConfidenceIntervals.arm1.le95CILB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.le; })) - Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.le; }));
			$scope.psaConfidenceIntervals.arm1.le95CIUB = Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.le; })) + Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.le; }));
			
			$scope.psaConfidenceIntervals.arm1.cost95CILB = (Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.cost; })) - Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.cost; })));
			$scope.psaConfidenceIntervals.arm1.cost95CIUB = (Stats.mean(data.arms['1'].psaResults.map(function(i) { return i.cost; })) + Stats.sd(data.arms['1'].psaResults.map(function(i) { return i.cost; })));
			
			$scope.psaConfidenceIntervals.diff.qale95CILB = Stats.mean($scope.psaDiffs.qale) - Stats.sd($scope.psaDiffs.qale);
			$scope.psaConfidenceIntervals.diff.qale95CIUB = Stats.mean($scope.psaDiffs.qale) + Stats.sd($scope.psaDiffs.qale);
			
			$scope.psaConfidenceIntervals.diff.le95CILB = Stats.mean($scope.psaDiffs.le) - Stats.sd($scope.psaDiffs.le);
			$scope.psaConfidenceIntervals.diff.le95CIUB = Stats.mean($scope.psaDiffs.le) + Stats.sd($scope.psaDiffs.le);
			
			$scope.psaConfidenceIntervals.diff.cost95CILB = (Stats.mean($scope.psaDiffs.cost) - Stats.sd($scope.psaDiffs.cost));
			$scope.psaConfidenceIntervals.diff.cost95CIUB = (Stats.mean($scope.psaDiffs.cost) + Stats.sd($scope.psaDiffs.cost));
			
			$scope.maxWTP = 10000;
			
			($scope.recalcCEAC = function() {
				$scope.ceac = [];
				$scope.ceacLabels = [];
				for (var i = 0; i <= 100; i++) {
					var wtp = i * ($scope.maxWTP/100);
					$scope.ceac.push($scope.psa.reduce(function(acc, val, i, arr) {
						if (val.x > 0 && val.y < 0) { // SE quadrant - count all
							++acc;
						}
						if (val.x > 0 && val.y > 0 && val.y/val.x < wtp) { // NE quadrant - count < WTP
							++acc;
						}
						if (val.x < 0 && val.y < 0 && val.y/val.x > wtp) { // SW quadrant - count > WTP
							++acc
						}
						return acc;
					}, 0)/$scope.psa.length * 100);
					$scope.ceacLabels.push(wtp);
				};
			})();
			$scope.ceacOptions = angular.copy($scope.options);
			$scope.ceacOptions.scales.xAxes[0].scaleLabel.labelString = "Willingness-to-pay threshold" + (data.fullElements.costs[0].currency !== undefined ? " (" + data.fullElements.costs[0].currency + " per QALY gained)" : "");
			$scope.ceacOptions.scales.yAxes[0].scaleLabel = {};
			$scope.ceacOptions.scales.yAxes[0].scaleLabel.labelString = "Likelihood of intervention being cost-effective (%)";
			$scope.ceacOptions.scales.yAxes[0].scaleLabel.display = true;
			$scope.ceacOptions.scales.yAxes[0].ticks.max = 100;
			$scope.ceacOptions.legend.display = false;
			$scope.ceacOptions.aspectRatio = 1.8;
			$scope.ceacOptions.tooltips.callbacks.label = function(tooltipItem, data) {
				return tooltipItem.yLabel.toFixed(1) + "%";
			}
		}
	});

}]);

PRIMEControllersT2D.controller("NewSimulationT2D", ["$scope", "$rootScope", "$routeParams", "$location", "SimulationServiceT2D", "FeatureFlags", function ($scope, $rootScope, $routeParams, $location, SimulationServiceT2D, FeatureFlags) {
	$scope.strings = {
		"title":"New Simulation"
	}
	$scope.obesityMode = FeatureFlags.obesityMode;
	
	if ($routeParams.id !== undefined) {
		$scope.simulation = SimulationServiceT2D.clone({simulationId:$routeParams.id});
		$scope.simulation.$promise.then(function(simulation) {
			delete simulation._id;
			simulation.name = simulation.name + " copy";
			simulation.sharedWith = [];
			simulation.creationDate = new Date().getTime();
			if (simulation.randomSeed === undefined) {
				simulation.randomSeed = 31415;
			}
		})

	} else {
		$scope.simulation = {
			name: "Simulation",
			patients: 500000,
			timeHorizon: 50,
			notes : "",
			creationDate: new Date().getTime(),
			psa: false,
			iterations: 1000,
			sampleTreatmentEffects: false,
			sampleCosts: false,
			sampleUtilities: false,
			randomSeed: 31415,
			obesityComplications: false,
			elements: {cohortIDs:[],
				treatmentIDs:[],
				costIDs:[],
				utilityIDs:[],
				countryIDs:[]
			},
			arms: {}
		};
	}

	
	$scope.runSimulation = function() {
		$scope.simulation["progress"] = "Waiting";
		
		SimulationServiceT2D.save($scope.simulation, function() { });
		
		$location.path("/t2d/simulations/")
	}
}]);

PRIMEControllersT2D.controller("ShareDocumentT2D", ["$scope", "$rootScope", "$http", "collection", "documentId", function ($scope, $rootScope, $http, collection, documentId) {

  $scope.submitShareRequest = function(mode) {

    const emails = $scope.form.emailsText
      .split('\n')
      .map(s => s.trim())
      .filter(Boolean);

    const payload = {
      emails,
      mode
    };

    $http.post(`/api/t2d/${collection}/${documentId}/share`, payload)
      .then(response => {
        $scope.result = response.data;
        $scope.getSharingInfo();
      })
      .catch(error => {
        $scope.result = error.data || { message: 'Request failed' };
      });
  };

  $scope.getSharingInfo = function() {
    $http.get(`/api/t2d/${collection}/${documentId}/share`)
      .then(function(response) {
        $scope.sharingInfo = response.data.sharedWith;
      })
      .catch(function(err) {
        $scope.sharingInfo = [(err.data?.message || 'Request failed')];
      });
  };

  $scope.getSharingInfo();
}]);

PRIMEControllersT2D.controller("ExportT2D", ["$scope", "$http", "$interval", "$window", "$modalInstance", "jobId", function ($scope, $http, $interval, $window, $modalInstance, jobId) {
  $scope.jobId = jobId;
  $scope.loading = true;
  $scope.result = null;

  var tick = function() {
    $http.get('/api/t2d/simulations/batchexport/' + jobId).then(function(res) {
      if (res.data.status === 'COMPLETED') {
        $scope.loading = false;
        $scope.result = res.data;
        $interval.cancel(pollInterval);
        if ($scope.result.downloadUrl) {
          $window.open($scope.result.downloadUrl, '_blank');
        }
        $modalInstance.close();
      }
    }, function(err) {
      console.error("Polling failed", err);
    });
  };

  var pollInterval = $interval(tick, 5000);
  tick();

  $scope.$on('$destroy', function() {
    $interval.cancel(pollInterval);
  });
}]);
